// Centralized route slug translations for all languages
// Maps canonical route identifier to localized URL slugs

type RouteSlugMap = {
  sk: string;
  cs: string;
  da: string;
  en: string;
  de: string;
};

// Route translation dictionary - ALL routes with trailing slashes (except home)
// NOTE: This is the single shared source of URL slugs. The server sitemap
// (server/index.ts) imports these maps — never duplicate slugs elsewhere.
export const routeTranslations: Record<string, RouteSlugMap> = {
  home: {
    sk: '/',
    cs: '/',
    da: '/',
    en: '/',
    de: '/',
  },
  pricing: {
    sk: '/cennik/',
    cs: '/cenik/',
    da: '/priser/',
    en: '/pricing/',
    de: '/preise/',
  },
  modules: {
    sk: '/moduly/',
    cs: '/moduly/',
    da: '/funktioner/',
    en: '/features/',
    de: '/funktionen/',
  },
  productAtlas: {
    sk: '/atlas/',
    cs: '/atlas/',
    da: '/atlas/',
    en: '/atlas/',
    de: '/atlas/',
  },
  about: {
    sk: '/o-nas/',
    cs: '/o-nas/',
    da: '/om-os/',
    en: '/about/',
    de: '/ueber-uns/',
  },
  contact: {
    sk: '/kontakt/',
    cs: '/kontakt/',
    da: '/kontakt/',
    en: '/contact/',
    de: '/kontakt/',
  },
  privacy: {
    sk: '/privacy/',
    cs: '/privacy/',
    da: '/privacy/',
    en: '/privacy/',
    de: '/privacy/',
  },
  terms: {
    sk: '/terms/',
    cs: '/terms/',
    da: '/terms/',
    en: '/terms/',
    de: '/terms/',
  },
  cookies: {
    sk: '/cookies/',
    cs: '/cookies/',
    da: '/cookies/',
    en: '/cookies/',
    de: '/cookies/',
  },
  gdpr: {
    sk: '/privacy/',
    cs: '/privacy/',
    da: '/privacy/',
    en: '/privacy/',
    de: '/privacy/',
  },
  dpa: {
    sk: '/dpa/',
    cs: '/dpa/',
    da: '/dpa/',
    en: '/dpa/',
    de: '/dpa/',
  },
  blog: {
    sk: '/blog/',
    cs: '/blog/',
    da: '/blog/',
    en: '/blog/',
    de: '/blog/',
  },
  partners: {
    sk: '/partneri/',
    cs: '/partneri/',
    da: '/partnere/',
    en: '/partners/',
    de: '/partner/',
  },
  videos: {
    sk: '/videa/',
    cs: '/videa/',
    da: '/videoer/',
    en: '/videos/',
    de: '/videos/',
  },
  bankConnect: {
    sk: '',
    cs: '',
    da: '/bank-connect/',
    en: '',
    de: '',
  },
  migrationGuide: {
    sk: '',
    cs: '',
    da: '/skift-til-bidmio/',
    en: '',
    de: '',
  },
  technology: {
    sk: '/security/',
    cs: '/security/',
    da: '/security/',
    en: '/security/',
    de: '/security/',
  },
  securitySubprocessors: {
    sk: '/security/subprocessors/',
    cs: '/security/subprocessors/',
    da: '/security/subprocessors/',
    en: '/security/subprocessors/',
    de: '/security/subprocessors/',
  },
  securityDataMap: {
    sk: '/security/data-map/',
    cs: '/security/data-map/',
    da: '/security/data-map/',
    en: '/security/data-map/',
    de: '/security/data-map/',
  },
  status: {
    sk: '/status/',
    cs: '/status/',
    da: '/status/',
    en: '/status/',
    de: '/status/',
  },
  constructionSoftware: {
    sk: '/stavebny-software/',
    cs: '/stavebni-software/',
    da: '/byggesoftware/',
    en: '/construction-software/',
    de: '/bausoftware/',
  },
  worldSurvive: {
    sk: '/ked-chyba-robota-a-peniaze/',
    cs: '/kdyz-chybi-prace-a-penize/',
    da: '/naar-opgaverne-mangler/',
    en: '/when-money-is-tight/',
    de: '/wenn-das-geld-knapp-ist/',
  },
  worldGrow: {
    sk: '/ked-chyba-poriadok/',
    cs: '/kdyz-chybi-poradek/',
    da: '/naar-overblikket-mangler/',
    en: '/when-the-business-grows/',
    de: '/wenn-der-betrieb-waechst/',
  },
  blackWorkArticle: {
    sk: '/praca-na-cierno/',
    cs: '/prace-nacerno/',
    da: '/sort-arbejde-i-byggeriet/',
    en: '/cash-in-hand-work/',
    de: '/schwarzarbeit/',
  },
  accountantArticle: {
    sk: '/uctovnictvo-a-uctovnicka/',
    cs: '/ucetnictvi-a-ucetni/',
    da: '/bogfoering-bilag-og-revisor/',
    en: '/bookkeeping-and-your-accountant/',
    de: '/buchhaltung-und-steuerberater/',
  },
  soloOffer: {
    sk: '/pre-zivnostnikov/',
    cs: '/pro-osvc/',
    da: '/til-enkeltmandsvirksomhed/',
    en: '/for-sole-traders/',
    de: '/fuer-einzelunternehmer/',
  },
  tradeElectrician: {
    sk: '/software-pre-elektrikarov/',
    cs: '/software-pro-elektrikare/',
    da: '/software-til-elektriker/',
    en: '/software-for-electricians/',
    de: '/software-fuer-elektriker/',
  },
  tradePlumber: {
    sk: '/software-pre-instalaterov/',
    cs: '/software-pro-instalatery/',
    da: '/software-til-vvs/',
    en: '/software-for-plumbers/',
    de: '/software-fuer-shk/',
  },
  tradePainter: {
    sk: '/software-pre-maliarov/',
    cs: '/software-pro-malire/',
    da: '/software-til-maler/',
    en: '/software-for-painters/',
    de: '/software-fuer-maler/',
  },
  tradeCarpenter: {
    sk: '/software-pre-stolarov-a-tesarov/',
    cs: '/software-pro-truhlare-a-tesare/',
    da: '/software-til-toemrer/',
    en: '/software-for-carpenters/',
    de: '/software-fuer-tischler-und-zimmerer/',
  },
  tradeGeneralContractor: {
    sk: '/software-pre-generalneho-dodavatela/',
    cs: '/software-pro-generalniho-dodavatele/',
    da: '/software-til-hovedentreprenor/',
    en: '/software-for-general-contractors/',
    de: '/software-fuer-bauunternehmen/',
  },
  tradeMason: {
    sk: '/software-pre-murarov/',
    cs: '',
    da: '/software-til-murer/',
    en: '',
    de: '',
  },
  tradeRoofer: {
    sk: '/software-pre-pokryvacov/',
    cs: '/software-pro-pokryvace/',
    da: '/software-til-tagdaekker/',
    en: '/software-for-roofers/',
    de: '/software-fuer-dachdecker/',
  },
  tradeSewer: {
    sk: '',
    cs: '',
    da: '/software-til-kloakmester/',
    en: '',
    de: '',
  },
  tradeService: {
    sk: '/servisny-system/',
    cs: '/servisni-system/',
    da: '/servicesystem/',
    en: '/field-service-software/',
    de: '/kundendienst-software/',
  },
  customerPortal: {
    sk: '/zakaznicky-portal/',
    cs: '/zakaznicky-portal/',
    da: '/kundeportal/',
    en: '/customer-portal/',
    de: '/kundenportal/',
  },
  bozp: {
    sk: '/bozp-software/',
    cs: '/bozp-software/',
    da: '/arbejdsmiljo/',
    en: '/health-and-safety-software/',
    de: '/arbeitsschutz-software/',
  },
  forAccountants: {
    sk: '/pre-uctovnikov/',
    cs: '/pro-ucetni/',
    da: '/til-revisorer/',
    en: '/for-accountants/',
    de: '/fuer-steuerberater/',
  },
  digitalBookkeeping: {
    sk: '',
    cs: '',
    da: '/digital-bogfoering/',
    en: '',
    de: '',
  },
  tradeWebsite: {
    sk: '/webstranka-pre-remeselnika/',
    cs: '/webova-stranka-pro-remeslnika/',
    da: '/hjemmeside-til-haandvaerker/',
    en: '/website-for-tradespeople/',
    de: '/website-fuer-handwerker/',
  },
  // SK merged into tradeWebsite (one long page); the old SK URL 301s there.
  constructionFirmWebsite: {
    sk: '',
    cs: '/webova-stranka-pro-stavebni-firmy/',
    da: '/hjemmeside-til-byggefirma/',
    en: '/website-for-construction-companies/',
    de: '/website-fuer-baufirmen/',
  },
  websiteCreation: {
    sk: '/tvorba-webu-pre-remeselnikov/',
    cs: '/tvorba-webu-pro-remeslniky/',
    da: '/vi-laver-hjemmesiden/',
    en: '/website-creation-for-tradespeople/',
    de: '/website-erstellung-fuer-handwerker/',
  },
  // SK merged into tradeWebsite (one long page); the old SK URL 301s there.
  serviceFirmWebsite: {
    sk: '',
    cs: '/webova-stranka-pro-servisni-firmy/',
    da: '/hjemmeside-til-servicefirma/',
    en: '/website-for-service-firms/',
    de: '/website-fuer-servicefirmen/',
  },
  priceCalculator: {
    sk: '/cenova-kalkulacka-pre-remeselnikov/',
    cs: '/cenova-kalkulacka-pro-remeslniky/',
    da: '/prisberegner-til-haandvaerker/',
    en: '/price-calculator-for-tradespeople/',
    de: '/preisrechner-fuer-handwerker/',
  },
  // White-label price calculator sold to painters (Danish pilot, then CZ/SK).
  // The calculator runs on pris.bidmio.dk/maler/ / cena.bidmio.cz/malir/; this page only sells it.
  priceCalculatorPainter: {
    sk: '/cenova-kalkulacka-pre-maliarov/',
    cs: '/cenova-kalkulacka-pro-malire/',
    da: '/prisberegner-til-maler/',
    en: '',
    de: '',
  },
  // Same calculator for floor firms (gulv-dk), on pris.bidmio.dk/gulv/.
  priceCalculatorFloor: {
    sk: '',
    cs: '',
    da: '/prisberegner-til-gulvfirma/',
    en: '',
    de: '',
  },
  // Business quizzes live under /quiz/: a dashboard of all tests, then each
  // quiz's own hub and per-trade pages. Danish site first.
  quizHub: {
    sk: '/kviz/',
    cs: '/kviz/',
    da: '/quiz/',
    en: '/quiz/',
    de: '/quiz/',
  },
  // Hourly-rate quiz: a hub plus one shareable page per trade. Each site has
  // its own country (bidmio.dk = Denmark). Danish first, other sites follow.
  // Paths are registered in pathnameToRouteKey by the loop further down.
  rateQuiz: {
    sk: '/kviz/kalkulacka-hodinovej-sadzby/',
    cs: '/kviz/hodinova-sazba/',
    da: '/quiz/timepris-beregner/',
    en: '/quiz/hourly-rate-calculator/',
    de: '/quiz/stundensatz-rechner/',
  },
  rateQuizPainter: {
    sk: '/kviz/kalkulacka-hodinovej-sadzby/maliar/',
    cs: '/kviz/hodinova-sazba/malir/',
    da: '/quiz/timepris-beregner/maler/',
    en: '/quiz/hourly-rate-calculator/painter-decorator/',
    de: '/quiz/stundensatz-rechner/maler/',
  },
  rateQuizCarpenter: {
    sk: '/kviz/kalkulacka-hodinovej-sadzby/tesar/',
    cs: '/kviz/hodinova-sazba/tesar/',
    da: '/quiz/timepris-beregner/toemrer/',
    en: '/quiz/hourly-rate-calculator/carpenter/',
    de: '/quiz/stundensatz-rechner/zimmerer/',
  },
  rateQuizElectrician: {
    sk: '/kviz/kalkulacka-hodinovej-sadzby/elektrikar/',
    cs: '/kviz/hodinova-sazba/elektrikar/',
    da: '/quiz/timepris-beregner/elektriker/',
    en: '/quiz/hourly-rate-calculator/electrician/',
    de: '/quiz/stundensatz-rechner/elektriker/',
  },
  rateQuizPlumber: {
    sk: '/kviz/kalkulacka-hodinovej-sadzby/instalater/',
    cs: '/kviz/hodinova-sazba/instalater/',
    da: '/quiz/timepris-beregner/vvs/',
    en: '/quiz/hourly-rate-calculator/plumber/',
    de: '/quiz/stundensatz-rechner/installateur/',
  },
  rateQuizMason: {
    sk: '/kviz/kalkulacka-hodinovej-sadzby/murar/',
    cs: '/kviz/hodinova-sazba/zednik/',
    da: '/quiz/timepris-beregner/murer/',
    en: '/quiz/hourly-rate-calculator/bricklayer/',
    de: '/quiz/stundensatz-rechner/maurer/',
  },
  rateQuizRoofer: {
    sk: '/kviz/kalkulacka-hodinovej-sadzby/pokryvac/',
    cs: '/kviz/hodinova-sazba/pokryvac/',
    da: '/quiz/timepris-beregner/tagdaekker/',
    en: '/quiz/hourly-rate-calculator/roofer/',
    de: '/quiz/stundensatz-rechner/dachdecker/',
  },
  // Employee-cost quiz ("Hvad koster en medarbejder?"): same shape as the
  // hourly-rate quiz, a hub plus one page per trade. Danish site first.
  employeeQuiz: {
    sk: '/kviz/cena-prace-zamestnanca/',
    cs: '/kviz/naklady-na-zamestnance/',
    da: '/quiz/medarbejder-beregner/',
    en: '/quiz/employee-cost-calculator/',
    de: '/quiz/mitarbeiterkosten-rechner/',
  },
  employeeQuizPainter: {
    sk: '/kviz/cena-prace-zamestnanca/maliar/',
    cs: '/kviz/naklady-na-zamestnance/malir/',
    da: '/quiz/medarbejder-beregner/maler/',
    en: '/quiz/employee-cost-calculator/painter-decorator/',
    de: '/quiz/mitarbeiterkosten-rechner/maler/',
  },
  employeeQuizCarpenter: {
    sk: '/kviz/cena-prace-zamestnanca/tesar/',
    cs: '/kviz/naklady-na-zamestnance/tesar/',
    da: '/quiz/medarbejder-beregner/toemrer/',
    en: '/quiz/employee-cost-calculator/carpenter/',
    de: '/quiz/mitarbeiterkosten-rechner/zimmerer/',
  },
  employeeQuizElectrician: {
    sk: '/kviz/cena-prace-zamestnanca/elektrikar/',
    cs: '/kviz/naklady-na-zamestnance/elektrikar/',
    da: '/quiz/medarbejder-beregner/elektriker/',
    en: '/quiz/employee-cost-calculator/electrician/',
    de: '/quiz/mitarbeiterkosten-rechner/elektriker/',
  },
  employeeQuizPlumber: {
    sk: '/kviz/cena-prace-zamestnanca/instalater/',
    cs: '/kviz/naklady-na-zamestnance/instalater/',
    da: '/quiz/medarbejder-beregner/vvs/',
    en: '/quiz/employee-cost-calculator/plumber/',
    de: '/quiz/mitarbeiterkosten-rechner/installateur/',
  },
  employeeQuizMason: {
    sk: '/kviz/cena-prace-zamestnanca/murar/',
    cs: '/kviz/naklady-na-zamestnance/zednik/',
    da: '/quiz/medarbejder-beregner/murer/',
    en: '/quiz/employee-cost-calculator/bricklayer/',
    de: '/quiz/mitarbeiterkosten-rechner/maurer/',
  },
  employeeQuizRoofer: {
    sk: '/kviz/cena-prace-zamestnanca/pokryvac/',
    cs: '/kviz/naklady-na-zamestnance/pokryvac/',
    da: '/quiz/medarbejder-beregner/tagdaekker/',
    en: '/quiz/employee-cost-calculator/roofer/',
    de: '/quiz/mitarbeiterkosten-rechner/dachdecker/',
  },
  // Van-cost quiz ("Hvad koster varebilen pr. time?"): hub plus one page per trade.
  vehicleQuiz: {
    sk: '/kviz/naklady-na-dodavku/',
    cs: '/kviz/naklady-na-dodavku/',
    da: '/quiz/varebil-beregner/',
    en: '/quiz/van-cost-calculator/',
    de: '/quiz/transporter-rechner/',
  },
  vehicleQuizPainter: {
    sk: '/kviz/naklady-na-dodavku/maliar/',
    cs: '/kviz/naklady-na-dodavku/malir/',
    da: '/quiz/varebil-beregner/maler/',
    en: '/quiz/van-cost-calculator/painter-decorator/',
    de: '/quiz/transporter-rechner/maler/',
  },
  vehicleQuizCarpenter: {
    sk: '/kviz/naklady-na-dodavku/tesar/',
    cs: '/kviz/naklady-na-dodavku/tesar/',
    da: '/quiz/varebil-beregner/toemrer/',
    en: '/quiz/van-cost-calculator/carpenter/',
    de: '/quiz/transporter-rechner/zimmerer/',
  },
  vehicleQuizElectrician: {
    sk: '/kviz/naklady-na-dodavku/elektrikar/',
    cs: '/kviz/naklady-na-dodavku/elektrikar/',
    da: '/quiz/varebil-beregner/elektriker/',
    en: '/quiz/van-cost-calculator/electrician/',
    de: '/quiz/transporter-rechner/elektriker/',
  },
  vehicleQuizPlumber: {
    sk: '/kviz/naklady-na-dodavku/instalater/',
    cs: '/kviz/naklady-na-dodavku/instalater/',
    da: '/quiz/varebil-beregner/vvs/',
    en: '/quiz/van-cost-calculator/plumber/',
    de: '/quiz/transporter-rechner/installateur/',
  },
  vehicleQuizMason: {
    sk: '/kviz/naklady-na-dodavku/murar/',
    cs: '/kviz/naklady-na-dodavku/zednik/',
    da: '/quiz/varebil-beregner/murer/',
    en: '/quiz/van-cost-calculator/bricklayer/',
    de: '/quiz/transporter-rechner/maurer/',
  },
  vehicleQuizRoofer: {
    sk: '/kviz/naklady-na-dodavku/pokryvac/',
    cs: '/kviz/naklady-na-dodavku/pokryvac/',
    da: '/quiz/varebil-beregner/tagdaekker/',
    en: '/quiz/van-cost-calculator/roofer/',
    de: '/quiz/transporter-rechner/dachdecker/',
  },
  // Quote-check quiz ("Tjener du på dit tilbud?"): hub plus one page per trade.
  quoteQuiz: {
    sk: '/kviz/kontrola-cenovej-ponuky/',
    cs: '/kviz/kontrola-nabidky/',
    da: '/quiz/tilbudstjek/',
    en: '/quiz/quote-check/',
    de: '/quiz/angebots-check/',
  },
  quoteQuizPainter: {
    sk: '/kviz/kontrola-cenovej-ponuky/maliar/',
    cs: '/kviz/kontrola-nabidky/malir/',
    da: '/quiz/tilbudstjek/maler/',
    en: '/quiz/quote-check/painter-decorator/',
    de: '/quiz/angebots-check/maler/',
  },
  quoteQuizCarpenter: {
    sk: '/kviz/kontrola-cenovej-ponuky/tesar/',
    cs: '/kviz/kontrola-nabidky/tesar/',
    da: '/quiz/tilbudstjek/toemrer/',
    en: '/quiz/quote-check/carpenter/',
    de: '/quiz/angebots-check/zimmerer/',
  },
  quoteQuizElectrician: {
    sk: '/kviz/kontrola-cenovej-ponuky/elektrikar/',
    cs: '/kviz/kontrola-nabidky/elektrikar/',
    da: '/quiz/tilbudstjek/elektriker/',
    en: '/quiz/quote-check/electrician/',
    de: '/quiz/angebots-check/elektriker/',
  },
  quoteQuizPlumber: {
    sk: '/kviz/kontrola-cenovej-ponuky/instalater/',
    cs: '/kviz/kontrola-nabidky/instalater/',
    da: '/quiz/tilbudstjek/vvs/',
    en: '/quiz/quote-check/plumber/',
    de: '/quiz/angebots-check/installateur/',
  },
  quoteQuizMason: {
    sk: '/kviz/kontrola-cenovej-ponuky/murar/',
    cs: '/kviz/kontrola-nabidky/zednik/',
    da: '/quiz/tilbudstjek/murer/',
    en: '/quiz/quote-check/bricklayer/',
    de: '/quiz/angebots-check/maurer/',
  },
  quoteQuizRoofer: {
    sk: '/kviz/kontrola-cenovej-ponuky/pokryvac/',
    cs: '/kviz/kontrola-nabidky/pokryvac/',
    da: '/quiz/tilbudstjek/tagdaekker/',
    en: '/quiz/quote-check/roofer/',
    de: '/quiz/angebots-check/dachdecker/',
  },
  // Material-markup quiz ("Er din materialeavance rigtig?"): hub plus one page per trade.
  materialQuiz: {
    sk: '/kviz/prirazka-na-material/',
    cs: '/kviz/prirazka-na-material/',
    da: '/quiz/materialeavance-beregner/',
    en: '/quiz/material-markup-calculator/',
    de: '/quiz/materialaufschlag-rechner/',
  },
  materialQuizPainter: {
    sk: '/kviz/prirazka-na-material/maliar/',
    cs: '/kviz/prirazka-na-material/malir/',
    da: '/quiz/materialeavance-beregner/maler/',
    en: '/quiz/material-markup-calculator/painter-decorator/',
    de: '/quiz/materialaufschlag-rechner/maler/',
  },
  materialQuizCarpenter: {
    sk: '/kviz/prirazka-na-material/tesar/',
    cs: '/kviz/prirazka-na-material/tesar/',
    da: '/quiz/materialeavance-beregner/toemrer/',
    en: '/quiz/material-markup-calculator/carpenter/',
    de: '/quiz/materialaufschlag-rechner/zimmerer/',
  },
  materialQuizElectrician: {
    sk: '/kviz/prirazka-na-material/elektrikar/',
    cs: '/kviz/prirazka-na-material/elektrikar/',
    da: '/quiz/materialeavance-beregner/elektriker/',
    en: '/quiz/material-markup-calculator/electrician/',
    de: '/quiz/materialaufschlag-rechner/elektriker/',
  },
  materialQuizPlumber: {
    sk: '/kviz/prirazka-na-material/instalater/',
    cs: '/kviz/prirazka-na-material/instalater/',
    da: '/quiz/materialeavance-beregner/vvs/',
    en: '/quiz/material-markup-calculator/plumber/',
    de: '/quiz/materialaufschlag-rechner/installateur/',
  },
  materialQuizMason: {
    sk: '/kviz/prirazka-na-material/murar/',
    cs: '/kviz/prirazka-na-material/zednik/',
    da: '/quiz/materialeavance-beregner/murer/',
    en: '/quiz/material-markup-calculator/bricklayer/',
    de: '/quiz/materialaufschlag-rechner/maurer/',
  },
  materialQuizRoofer: {
    sk: '/kviz/prirazka-na-material/pokryvac/',
    cs: '/kviz/prirazka-na-material/pokryvac/',
    da: '/quiz/materialeavance-beregner/tagdaekker/',
    en: '/quiz/material-markup-calculator/roofer/',
    de: '/quiz/materialaufschlag-rechner/dachdecker/',
  },
  // First-employee quiz ("Hvornår kan første ansatte betale sig?"): hub plus one page per trade.
  hireQuiz: {
    sk: '/kviz/prvy-zamestnanec/',
    cs: '/kviz/prvni-zamestnanec/',
    da: '/quiz/foerste-ansatte-beregner/',
    en: '/quiz/first-employee-calculator/',
    de: '/quiz/erster-mitarbeiter-rechner/',
  },
  hireQuizPainter: {
    sk: '/kviz/prvy-zamestnanec/maliar/',
    cs: '/kviz/prvni-zamestnanec/malir/',
    da: '/quiz/foerste-ansatte-beregner/maler/',
    en: '/quiz/first-employee-calculator/painter-decorator/',
    de: '/quiz/erster-mitarbeiter-rechner/maler/',
  },
  hireQuizCarpenter: {
    sk: '/kviz/prvy-zamestnanec/tesar/',
    cs: '/kviz/prvni-zamestnanec/tesar/',
    da: '/quiz/foerste-ansatte-beregner/toemrer/',
    en: '/quiz/first-employee-calculator/carpenter/',
    de: '/quiz/erster-mitarbeiter-rechner/zimmerer/',
  },
  hireQuizElectrician: {
    sk: '/kviz/prvy-zamestnanec/elektrikar/',
    cs: '/kviz/prvni-zamestnanec/elektrikar/',
    da: '/quiz/foerste-ansatte-beregner/elektriker/',
    en: '/quiz/first-employee-calculator/electrician/',
    de: '/quiz/erster-mitarbeiter-rechner/elektriker/',
  },
  hireQuizPlumber: {
    sk: '/kviz/prvy-zamestnanec/instalater/',
    cs: '/kviz/prvni-zamestnanec/instalater/',
    da: '/quiz/foerste-ansatte-beregner/vvs/',
    en: '/quiz/first-employee-calculator/plumber/',
    de: '/quiz/erster-mitarbeiter-rechner/installateur/',
  },
  hireQuizMason: {
    sk: '/kviz/prvy-zamestnanec/murar/',
    cs: '/kviz/prvni-zamestnanec/zednik/',
    da: '/quiz/foerste-ansatte-beregner/murer/',
    en: '/quiz/first-employee-calculator/bricklayer/',
    de: '/quiz/erster-mitarbeiter-rechner/maurer/',
  },
  hireQuizRoofer: {
    sk: '/kviz/prvy-zamestnanec/pokryvac/',
    cs: '/kviz/prvni-zamestnanec/pokryvac/',
    da: '/quiz/foerste-ansatte-beregner/tagdaekker/',
    en: '/quiz/first-employee-calculator/roofer/',
    de: '/quiz/erster-mitarbeiter-rechner/dachdecker/',
  },
  // Free-work quiz ("Hvad koster gratis arbejde?"): hub plus one page per trade.
  freeWorkQuiz: { sk: '/kviz/praca-zadarmo/', cs: '/kviz/prace-zadarmo/', da: '/quiz/gratis-arbejde-beregner/', en: '/quiz/free-work-calculator/', de: '/quiz/gratisarbeit-rechner/' },
  freeWorkQuizPainter: { sk: '/kviz/praca-zadarmo/maliar/', cs: '/kviz/prace-zadarmo/malir/', da: '/quiz/gratis-arbejde-beregner/maler/', en: '/quiz/free-work-calculator/painter-decorator/', de: '/quiz/gratisarbeit-rechner/maler/' },
  freeWorkQuizCarpenter: { sk: '/kviz/praca-zadarmo/tesar/', cs: '/kviz/prace-zadarmo/tesar/', da: '/quiz/gratis-arbejde-beregner/toemrer/', en: '/quiz/free-work-calculator/carpenter/', de: '/quiz/gratisarbeit-rechner/zimmerer/' },
  freeWorkQuizElectrician: { sk: '/kviz/praca-zadarmo/elektrikar/', cs: '/kviz/prace-zadarmo/elektrikar/', da: '/quiz/gratis-arbejde-beregner/elektriker/', en: '/quiz/free-work-calculator/electrician/', de: '/quiz/gratisarbeit-rechner/elektriker/' },
  freeWorkQuizPlumber: { sk: '/kviz/praca-zadarmo/instalater/', cs: '/kviz/prace-zadarmo/instalater/', da: '/quiz/gratis-arbejde-beregner/vvs/', en: '/quiz/free-work-calculator/plumber/', de: '/quiz/gratisarbeit-rechner/installateur/' },
  freeWorkQuizMason: { sk: '/kviz/praca-zadarmo/murar/', cs: '/kviz/prace-zadarmo/zednik/', da: '/quiz/gratis-arbejde-beregner/murer/', en: '/quiz/free-work-calculator/bricklayer/', de: '/quiz/gratisarbeit-rechner/maurer/' },
  freeWorkQuizRoofer: { sk: '/kviz/praca-zadarmo/pokryvac/', cs: '/kviz/prace-zadarmo/pokryvac/', da: '/quiz/gratis-arbejde-beregner/tagdaekker/', en: '/quiz/free-work-calculator/roofer/', de: '/quiz/gratisarbeit-rechner/dachdecker/' },
  // Obligations-and-rights checklist: one page per site under that country's law (SK and CZ share the path; the domain decides).
  rightsQuiz: { sk: '/kviz/povinnosti-a-prava/', cs: '/kviz/povinnosti-a-prava/', da: '/quiz/pligter-og-rettigheder/', en: '/quiz/duties-and-rights/', de: '/quiz/pflichten-und-rechte/' },
  // Late-payer quiz ("Hvad koster en dårlig betaler?"): hub plus one page per trade.
  latePayerQuiz: {
    sk: '/kviz/omeskane-platby/',
    cs: '/kviz/neplatici-zakaznik/',
    da: '/quiz/betaler-beregner/',
    en: '/quiz/late-payment-calculator/',
    de: '/quiz/zahlungsverzug-rechner/',
  },
  latePayerQuizPainter: {
    sk: '/kviz/omeskane-platby/maliar/',
    cs: '/kviz/neplatici-zakaznik/malir/',
    da: '/quiz/betaler-beregner/maler/',
    en: '/quiz/late-payment-calculator/painter-decorator/',
    de: '/quiz/zahlungsverzug-rechner/maler/',
  },
  latePayerQuizCarpenter: {
    sk: '/kviz/omeskane-platby/tesar/',
    cs: '/kviz/neplatici-zakaznik/tesar/',
    da: '/quiz/betaler-beregner/toemrer/',
    en: '/quiz/late-payment-calculator/carpenter/',
    de: '/quiz/zahlungsverzug-rechner/zimmerer/',
  },
  latePayerQuizElectrician: {
    sk: '/kviz/omeskane-platby/elektrikar/',
    cs: '/kviz/neplatici-zakaznik/elektrikar/',
    da: '/quiz/betaler-beregner/elektriker/',
    en: '/quiz/late-payment-calculator/electrician/',
    de: '/quiz/zahlungsverzug-rechner/elektriker/',
  },
  latePayerQuizPlumber: {
    sk: '/kviz/omeskane-platby/instalater/',
    cs: '/kviz/neplatici-zakaznik/instalater/',
    da: '/quiz/betaler-beregner/vvs/',
    en: '/quiz/late-payment-calculator/plumber/',
    de: '/quiz/zahlungsverzug-rechner/installateur/',
  },
  latePayerQuizMason: {
    sk: '/kviz/omeskane-platby/murar/',
    cs: '/kviz/neplatici-zakaznik/zednik/',
    da: '/quiz/betaler-beregner/murer/',
    en: '/quiz/late-payment-calculator/bricklayer/',
    de: '/quiz/zahlungsverzug-rechner/maurer/',
  },
  latePayerQuizRoofer: {
    sk: '/kviz/omeskane-platby/pokryvac/',
    cs: '/kviz/neplatici-zakaznik/pokryvac/',
    da: '/quiz/betaler-beregner/tagdaekker/',
    en: '/quiz/late-payment-calculator/roofer/',
    de: '/quiz/zahlungsverzug-rechner/dachdecker/',
  },
  // Legal notice (Impressum) exists only on the German site.
  impressum: {
    sk: '',
    cs: '',
    da: '',
    en: '',
    de: '/impressum/',
  },
  wholeFirm: {
    sk: '/informacny-system-pre-firmu/',
    cs: '/cela-firma-v-jednom/',
    da: '/hele-firmaet-i-et-system/',
    en: '/the-whole-firm-in-one-system/',
    de: '/der-ganze-betrieb-in-einem-system/',
  },
  aiAssistant: {
    sk: '/ai-v-bidmio/',
    cs: '/ai-v-bidmiu/',
    da: '/ai-i-bidmio/',
    en: '/ai-in-bidmio/',
    de: '/ki-in-bidmio/',
  },
  // Comparison pages are locale-specific: Danish competitors only on bidmio.dk,
  // local SK/CZ competitors only on bidmio.sk / bidmio.cz, and the whole
  // comparison section is hidden on bidmio.com (en) for now. Empty string =
  // route does not exist in that locale (SPA 404, excluded from sitemap/hreflang).
  comparisonHub: {
    sk: '/porovnanie/',
    cs: '/srovnani/',
    da: '/sammenlign/',
    en: '',
    de: '',
  },
  comparisonMinuba: {
    sk: '',
    cs: '',
    da: '/sammenlign/bidmio-vs-minuba/',
    en: '',
    de: '',
  },
  comparisonOrdrestyring: {
    sk: '',
    cs: '',
    da: '/sammenlign/bidmio-vs-ordrestyring/',
    en: '',
    de: '',
  },
  comparisonApacta: {
    sk: '',
    cs: '',
    da: '/sammenlign/bidmio-vs-apacta/',
    en: '',
    de: '',
  },
  comparisonKala: {
    sk: '',
    cs: '',
    da: '/sammenlign/bidmio-vs-kala/',
    en: '',
    de: '',
  },
  comparisonEkomplet: {
    sk: '',
    cs: '',
    da: '',
    en: '',
    de: '',
  },
  comparisonKros: {
    sk: '/porovnanie/bidmio-vs-kros/',
    cs: '/srovnani/bidmio-vs-kros/',
    da: '',
    en: '',
    de: '',
  },
  comparisonPlanradar: {
    sk: '/porovnanie/bidmio-vs-planradar/',
    cs: '/srovnani/bidmio-vs-planradar/',
    da: '',
    en: '',
    de: '',
  },
  comparisonPohoda: {
    sk: '/porovnanie/bidmio-vs-pohoda/',
    cs: '/srovnani/bidmio-vs-pohoda/',
    da: '',
    en: '',
    de: '',
  },
  comparisonStavario: {
    sk: '/porovnanie/bidmio-vs-stavario/',
    cs: '/srovnani/bidmio-vs-stavario/',
    da: '',
    en: '',
    de: '',
  },
  comparisonSuperfaktura: {
    sk: '/porovnanie/bidmio-vs-superfaktura/',
    cs: '',
    da: '',
    en: '',
    de: '',
  },
  comparisonIdoklad: {
    sk: '/porovnanie/bidmio-vs-idoklad/',
    cs: '/srovnani/bidmio-vs-idoklad/',
    da: '',
    en: '',
    de: '',
  },
  comparisonDinero: {
    sk: '',
    cs: '',
    da: '/sammenlign/bidmio-vs-dinero/',
    en: '',
    de: '',
  },
  comparisonBilly: {
    sk: '',
    cs: '',
    da: '/sammenlign/bidmio-vs-billy/',
    en: '',
    de: '',
  },
  comparisonEconomic: {
    sk: '',
    cs: '',
    da: '/sammenlign/bidmio-vs-e-conomic/',
    en: '',
    de: '',
  },
  blogOrderManagement: {
    sk: '/blog/riadenie-zakaziek-pre-remeselnkov/',
    cs: '/blog/rizeni-zakazek-pro-remeslniky/',
    da: '',
    en: '',
    de: '/blog/auftragsverwaltung-handwerk/',
  },
  blogTimeRegistration: {
    sk: '/blog/digitalna-evidencia-casu-remesla/',
    cs: '/blog/digitalni-evidence-casu-remeslnici/',
    da: '/blog/digital-tidsregistrering-handvaerkere/',
    en: '/blog/digital-time-tracking-craftsmen/',
    de: '/blog/digitale-zeiterfassung-handwerk/',
  },
  blogQrOnSite: {
    sk: '/blog/qr-kody-na-stavbe/',
    cs: '/blog/qr-kody-na-stavenisti/',
    da: '/blog/qr-koder-paa-byggepladsen/',
    en: '/blog/qr-codes-on-the-job-site/',
    de: '/blog/qr-codes-auf-der-baustelle/',
  },
  blogWebsiteLeads: {
    sk: '/blog/ako-ziskat-zakazky-z-webu/',
    cs: '/blog/jak-ziskat-zakazky-z-webu/',
    da: '',
    en: '',
    de: '',
  },
  blogQuoteFormCalculator: {
    sk: '/blog/cenova-kalkulacka-a-dopytovy-formular/',
    cs: '/blog/cenova-kalkulacka-a-poptavkovy-formular/',
    da: '',
    en: '',
    de: '',
  },
  blogOrderManagementSystems: {
    sk: '/blog/system-riadenia-zakaziek-slovensko/',
    cs: '/blog/system-rizeni-zakazek-cesko/',
    da: '',
    en: '',
    de: '',
  },
  blogDigitalWorkOrder: {
    sk: '/blog/digitalny-pracovny-vykaz/',
    cs: '/blog/digitalni-pracovni-vykaz/',
    da: '/blog/digital-arbejdsseddel/',
    en: '/blog/digital-work-order/',
    de: '/blog/digitaler-arbeitsauftrag/',
  },
  blogQualityAssurance: {
    sk: '/blog/zabezpecenie-kvality-stavebnictvo/',
    cs: '/blog/zajisteni-kvality-stavebnictvi/',
    da: '/blog/kvalitetssikring-byggeri/',
    en: '/blog/quality-assurance-construction/',
    de: '/blog/qualitaetssicherung-bau/',
  },
  blogServiceAgreements: {
    sk: '/blog/servisne-zmluvy-software/',
    cs: '/blog/servisni-smlouvy-software/',
    da: '/blog/serviceaftaler-software/',
    en: '/blog/service-agreements-software/',
    de: '/blog/wartungsvertraege-software/',
  },
  blogFinancialManagement: {
    sk: '/blog/financne-riadenie-remesla/',
    cs: '/blog/financni-rizeni-remesla/',
    da: '/blog/okonomistyring-handvaerker/',
    en: '/blog/financial-management-craftsmen/',
    de: '/blog/finanzsteuerung-handwerk/',
  },
  blogMaterialRegistration: {
    sk: '/blog/registracia-materialov-remesla/',
    cs: '/blog/registrace-materialu-remesla/',
    da: '/blog/materialeregistrering-handvaerker/',
    en: '/blog/material-registration-craftsmen/',
    de: '/blog/materialerfassung-handwerk/',
  },
  blogOrderManagementElectricians: {
    sk: '/blog/riadenie-zakazok-elektrikari/',
    cs: '/blog/rizeni-zakazek-elektrikari/',
    da: '/blog/ordrestyring-elektrikere/',
    en: '/blog/order-management-electricians/',
    de: '/blog/auftragsverwaltung-elektriker/',
  },
  blogOrderManagementPainters: {
    sk: '/blog/riadenie-zakazok-maliari/',
    cs: '/blog/rizeni-zakazek-maliri/',
    da: '/blog/ordrestyring-malere/',
    en: '/blog/order-management-painters/',
    de: '/blog/auftragsverwaltung-maler/',
  },
  blogDigitalizationGuide: {
    sk: '/blog/digitalizacia-stavebnej-firmy/',
    cs: '/blog/digitalizace-stavebni-firmy/',
    da: '/blog/digitaliser-din-byggefirma/',
    en: '/blog/digitalize-construction-company/',
    de: '/blog/bauunternehmen-digitalisieren/',
  },
  blogJobPricing: {
    sk: '/blog/ako-ocenit-stavebne-prace/',
    cs: '/blog/jak-ocenit-stavebni-prace/',
    da: '/blog/prissaetning-byggeopgaver/',
    en: '/blog/how-to-price-construction-jobs/',
    de: '/blog/bauauftraege-kalkulieren/',
  },
  blogProjectManagementGuide: {
    sk: '/blog/riadenie-stavebnych-projektov-kompletny-sprievodca/',
    cs: '/blog/rizeni-stavebnich-projektu-kompletni-pruvodce/',
    da: '/blog/bygningsprojektledelse-komplet-guide/',
    en: '/blog/construction-project-management-complete-guide/',
    de: '/blog/bauprojektmanagement-leitfaden/',
  },
  blogJobManagementSystem: {
    sk: '/blog/zakazkovy-system/',
    cs: '/blog/zakazkovy-system/',
    da: '/blog/ordresystem-til-handvaerkere/',
    en: '/blog/job-management-system/',
    de: '/blog/auftragsmanagement-system/',
  },
  blogEInvoicing2027Sk: {
    sk: '/blog/elektronicka-fakturacia-2027-stavebne-firmy/',
    cs: '',
    da: '',
    en: '',
    de: '',
  },
  blogConstructionDocsTemplates: {
    sk: '/blog/supis-vykonanych-prac-vzor/',
    cs: '/blog/soupis-provedenych-praci-vzor/',
    da: '',
    en: '',
    de: '',
  },
  blogSiteManagerVsSupervisor: {
    sk: '/blog/stavebny-dozor-vs-stavbyveduci/',
    cs: '/blog/stavebni-dozor-vs-stavbyvedouci/',
    da: '',
    en: '',
    de: '',
  },
  blogDigitalBureaucracyGuide: {
    sk: '/blog/ako-prezit-byrokraciu-stavebnictvo/',
    cs: '/blog/jak-prezit-byrokracii-stavebnictvi/',
    da: '',
    en: '',
    de: '',
  },
  blogAiSiteDiary: {
    sk: '/blog/ai-stavebny-dennik-hlasovy-zapis/',
    cs: '/blog/ai-stavebni-denik-hlasovy-zapis/',
    da: '',
    en: '',
    de: '',
  },
  blogServiceProtocol: {
    sk: '/blog/servisny-protokol-vzor/',
    cs: '/blog/servisni-protokol-vzor/',
    da: '',
    en: '',
    de: '',
  },
  blogMigrationToBidmio: {
    sk: '/blog/migracia-do-bidmio-z-pohoda-kros-money/',
    cs: '/blog/migrace-do-bidmio-z-pohody-money-heliosu/',
    da: '',
    en: '',
    de: '',
  },
  blogAppVsSystem: {
    sk: '/blog/appka-alebo-system-pre-remeselnikov/',
    cs: '/blog/aplikace-nebo-system-pro-remeslniky/',
    da: '/blog/app-eller-system-til-haandvaerkere/',
    en: '/blog/app-or-system-for-tradespeople/',
    de: '/blog/app-oder-system-fuer-handwerker/',
  },
  blogAccountingModule: {
    sk: '/blog/uctovnictvo-pre-stavebne-firmy/',
    cs: '/blog/ucetnictvi-pro-stavebni-firmy/',
    da: '/blog/regnskabsprogram-til-haandvaerkere/',
    en: '/blog/construction-accounting-software-module/',
    de: '',
  },
  blogAiConstruction: {
    sk: '/blog/ai-v-stavebnictve/',
    cs: '/blog/ai-ve-stavebnictvi/',
    da: '/blog/ai-i-byggebranchen/',
    en: '/blog/ai-in-construction/',
    de: '/blog/ki-im-bau/',
  },
  blogAiAgentConstruction: {
    sk: '/blog/ai-agent-pre-stavebnu-firmu/',
    cs: '/blog/ai-agent-pro-stavebni-firmy/',
    da: '/blog/ai-agent-til-haandvaerkere/',
    en: '/blog/ai-agent-for-contractors/',
    de: '/blog/ki-agent-handwerk/',
  },
  blogCostForecastingEac: {
    sk: '/blog/predpoved-nakladov-eac-etc/',
    cs: '/blog/predpoved-nakladu-eac-etc/',
    da: '/blog/omkostningsprognose-eac-etc/',
    en: '/blog/cost-forecasting-eac-etc/',
    de: '/blog/kostenprognose-eac-etc/',
  },
  blogBillOfQuantities: {
    sk: '/blog/supis-prac-vykaz-vymer/',
    cs: '/blog/soupis-praci-vykaz-vymer/',
    da: '/blog/tilbudsliste-maengdefortegnelse/',
    en: '/blog/bill-of-quantities/',
    de: '/blog/leistungsverzeichnis/',
  },
  blogChangeOrders: {
    sk: '/blog/zmenove-listy-viacprace/',
    cs: '/blog/zmenove-listy-viceprace/',
    da: '/blog/aendringsordrer-byggeri/',
    en: '/blog/change-orders-construction/',
    de: '/blog/nachtraege-bau/',
  },
  blogConstructionReporting: {
    sk: '/blog/vykazy-reporting-stavebnictvo/',
    cs: '/blog/vykazy-reporting-stavebnictvi/',
    da: '/blog/rapportering-byggeri/',
    en: '/blog/construction-reporting/',
    de: '/blog/berichtswesen-bau/',
  },
  blogGanttScheduling: {
    sk: '/blog/ganttov-diagram-harmonogram-stavby/',
    cs: '/blog/ganttuv-diagram-harmonogram-stavby/',
    da: '/blog/gantt-diagram-byggeplan/',
    en: '/blog/gantt-chart-construction-schedule/',
    de: '/blog/gantt-diagramm-bauzeitenplan/',
  },
  blogAuditTrail: {
    sk: '/blog/audit-historia-zmien-stavba/',
    cs: '/blog/audit-historie-zmen-stavba/',
    da: '/blog/revisionsspor-byggeri/',
    en: '/blog/audit-trail-construction/',
    de: '/blog/audit-trail-bau/',
  },
  // Free quote tool for painters (bidmio.dk only for now).
  quoteToolPainter: {
    sk: '/cenova-ponuka-zadarmo/maliar/',
    cs: '/cenova-nabidka-zdarma/malir/',
    da: '/gratis-tilbud/maler/',
    en: '/free-quote/painter-decorator/',
    de: '/kostenloses-angebot/maler/',
  },
  // Free quote tool for masons and tilers: named after the trade that tiles in each country
  // (DK murer, SK/CZ obkladač, DE Fliesenleger, UK tiler).
  quoteToolMason: {
    sk: '/cenova-ponuka-zadarmo/obkladac/',
    cs: '/cenova-nabidka-zdarma/obkladac/',
    da: '/gratis-tilbud/murer/',
    en: '/free-quote/tiler/',
    de: '/kostenloses-angebot/fliesenleger/',
  },
  // Free quote tool for carpenters, named like each site's carpenter quiz (DK tømrer, SK tesár,
  // CZ tesař, DE Zimmerer, UK carpenter), so ?rate= from the carpenter rate result lands on its tool.
  quoteToolCarpenter: {
    sk: '/cenova-ponuka-zadarmo/tesar/',
    cs: '/cenova-nabidka-zdarma/tesar/',
    da: '/gratis-tilbud/toemrer/',
    en: '/free-quote/carpenter/',
    de: '/kostenloses-angebot/zimmerer/',
  },
};

// Module slug translations (canonical Slovak slug -> localized slugs)
// Shared source for both client routing and the server sitemap.
export const moduleSlugTranslations: Record<string, RouteSlugMap> = {
  'projektove-riadenie': {
    sk: 'projektove-riadenie',
    cs: 'projektove-rizeni',
    da: 'projektstyring',
    en: 'project-management',
    de: 'projektmanagement',
  },
  'vykaz-prace-a-evidencia-dochadzky': {
    sk: 'vykaz-prace-a-evidencia-dochadzky',
    cs: 'vykaz-prace-a-evidence-dochazky',
    da: 'timeregistrering',
    en: 'time-tracking-attendance',
    de: 'zeiterfassung',
  },
  'online-fakturacia': {
    sk: 'online-fakturacia',
    cs: 'online-fakturace',
    da: 'online-fakturering',
    en: 'online-invoicing',
    de: 'online-rechnungen',
  },
  'crm-system-prehlad-zakaznikov': {
    sk: 'crm-system-prehlad-zakaznikov',
    cs: 'crm-system-prehled-zakazniku',
    da: 'crm-system-kundeoversigt',
    en: 'crm-system-customer-overview',
    de: 'crm-kundenverwaltung',
  },
  'riadenie-timov': {
    sk: 'riadenie-timov',
    cs: 'rizeni-tymu',
    da: 'teamledelse',
    en: 'team-management',
    de: 'teamverwaltung',
  },
  'cenove-ponuky': {
    sk: 'cenove-ponuky',
    cs: 'cenove-nabidky',
    da: 'pristilbud',
    en: 'price-quotes',
    de: 'angebote',
  },
  'sprava-dokumentov': {
    sk: 'sprava-dokumentov',
    cs: 'sprava-dokumentu',
    da: 'dokumentstyring',
    en: 'document-management',
    de: 'dokumentenverwaltung',
  },
  'sklad-materialy': {
    sk: 'sklad-materialy',
    cs: 'sklad-materialy',
    da: 'lager-materialer',
    en: 'warehouse-materials',
    de: 'lager-material',
  },
  'kalendar-planovanie': {
    sk: 'kalendar-planovanie',
    cs: 'kalendar-planovani',
    da: 'kalender-planlaegning',
    en: 'calendar-planning',
    de: 'kalender-einsatzplanung',
  },
  'bezpecnost-kvalita': {
    sk: 'bezpecnost-kvalita',
    cs: 'bezpecnost-kvalita',
    da: 'sikkerhed-kvalitet',
    en: 'safety-quality',
    de: 'arbeitsschutz-qualitaet',
  },
  'mobilna-aplikacia': {
    sk: 'mobilna-aplikacia',
    cs: 'mobilni-aplikace',
    da: 'mobil-app',
    en: 'mobile-app',
    de: 'mobile-app',
  },
  'sprava-techniky': {
    sk: 'sprava-techniky',
    cs: 'sprava-techniky',
    da: 'udstyrsstyring',
    en: 'equipment-management',
    de: 'geraeteverwaltung',
  },
  'servis': {
    sk: 'servis',
    cs: 'servisni-vyjezdy',
    da: 'serviceudkald',
    en: 'field-service',
    de: 'kundendienst',
  },
  'firemny-web': {
    sk: 'firemny-web',
    cs: 'firemni-web',
    da: 'firmahjemmeside',
    en: 'company-website',
    de: 'firmenwebsite',
  },
  'formulare': {
    sk: 'formulare',
    cs: 'formulare',
    da: 'formularer',
    en: 'web-forms',
    de: 'webformulare',
  },
  'schvalenia': {
    sk: 'schvalenia',
    cs: 'schvaleni',
    da: 'godkendelser',
    en: 'approvals',
    de: 'freigaben',
  },
  'firemne-vydavky': {
    sk: 'firemne-vydavky',
    cs: 'firemni-vydaje',
    da: 'virksomhedsudgifter',
    en: 'company-expenses',
    de: 'betriebsausgaben',
  },
  'subkontraktori': {
    sk: 'subkontraktori',
    cs: 'subkontraktori',
    da: 'underentreprenoerer',
    en: 'subcontractors',
    de: 'nachunternehmer',
  },
  'stavebny-dennik': {
    sk: 'stavebny-dennik',
    cs: 'stavebni-denik',
    da: 'byggeriets-dagbog',
    en: 'construction-diary',
    de: 'bautagebuch',
  },
  'spracovanie-dokladov': {
    sk: 'spracovanie-dokladov',
    cs: 'zpracovani-dokladu',
    da: 'dokumentbehandling',
    en: 'document-processing',
    de: 'belegerfassung',
  },
  'sledovanie-materialov': {
    sk: 'sledovanie-materialov',
    cs: 'sledovani-materialu',
    da: 'materialesporing',
    en: 'materials-tracking',
    de: 'materialverfolgung',
  },
  'majetok-firmy': {
    sk: 'majetok-firmy',
    cs: 'majetek-firmy',
    da: 'virksomhedsaktiver',
    en: 'company-assets',
    de: 'betriebsvermoegen',
  },
  'vozidla-trasy': {
    sk: 'vozidla-trasy',
    cs: 'vozidla-trasy',
    da: 'koeretoejer-ruter',
    en: 'vehicles-routes',
    de: 'fahrzeuge-routen',
  },
  'fakturacny-modul': {
    sk: 'fakturacny-modul',
    cs: 'fakturacni-modul',
    da: 'faktureringsmodul',
    en: 'invoicing-module',
    de: 'rechnungsmodul',
  },
  'uctovnictvo': {
    sk: 'uctovnictvo',
    cs: 'ucetnictvi',
    da: 'regnskab',
    en: 'accounting',
    de: '',
  },
  'mzdy': {
    sk: 'mzdy',
    cs: 'mzdy',
    da: 'loen',
    en: 'payroll',
    de: '',
  },
  'bankovnictvo': {
    sk: 'bankovnictvo',
    cs: 'bankovnictvi',
    da: 'bank',
    en: 'banking',
    de: '',
  },
  'reporting-analytika': {
    sk: 'reporting-analytika',
    cs: 'reporting-analytika',
    da: 'rapportering-analyse',
    en: 'reporting-analytics',
    de: 'berichte-analysen',
  },
  'kontrola-nakladov': {
    sk: 'kontrola-nakladov',
    cs: 'kontrola-nakladu',
    da: 'omkostningskontrol',
    en: 'cost-control',
    de: 'kostenkontrolle',
  },
  'kalkulacie': {
    sk: 'kalkulacie',
    cs: 'kalkulace',
    da: 'kalkulationer',
    en: 'calculations',
    de: 'kalkulation',
  },
};

// Reverse map: pathname -> route key (for all languages)
// Supports both with and without trailing slashes for compatibility
// All comparison slugs and their routing keys. Availability per locale comes
// from routeTranslations ('' = page does not exist in that locale): Danish
// competitors only on bidmio.dk, local SK/CZ competitors only on .sk/.cz.
export const COMPARISON_SLUGS = [
  { slug: 'minuba', routeKey: 'comparisonMinuba' },
  { slug: 'ordrestyring', routeKey: 'comparisonOrdrestyring' },
  { slug: 'apacta', routeKey: 'comparisonApacta' },
  { slug: 'kala', routeKey: 'comparisonKala' },
  { slug: 'kros', routeKey: 'comparisonKros' },
  { slug: 'planradar', routeKey: 'comparisonPlanradar' },
  { slug: 'pohoda', routeKey: 'comparisonPohoda' },
  { slug: 'stavario', routeKey: 'comparisonStavario' },
  { slug: 'superfaktura', routeKey: 'comparisonSuperfaktura' },
  { slug: 'idoklad', routeKey: 'comparisonIdoklad' },
  { slug: 'dinero', routeKey: 'comparisonDinero' },
  { slug: 'billy', routeKey: 'comparisonBilly' },
  { slug: 'economic', routeKey: 'comparisonEconomic' },
] as const;

const pathnameToRouteKey: Record<string, string> = {
  // Home
  '/': 'home',
  
  // Pricing
  '/cennik': 'pricing',
  '/cennik/': 'pricing',
  '/cenik': 'pricing',
  '/cenik/': 'pricing',
  '/priser': 'pricing',
  '/priser/': 'pricing',
  '/pricing': 'pricing',
  '/pricing/': 'pricing',
  
  // Modules/Features
  '/moduly': 'modules',
  '/moduly/': 'modules',
  '/funktioner': 'modules',
  '/funktioner/': 'modules',
  '/features': 'modules',
  '/features/': 'modules',
  '/atlas': 'productAtlas',
  '/atlas/': 'productAtlas',
  
  // About
  '/o-nas': 'about',
  '/o-nas/': 'about',
  '/om-os': 'about',
  '/om-os/': 'about',
  '/about': 'about',
  '/about/': 'about',
  
  // Contact
  '/kontakt': 'contact',
  '/kontakt/': 'contact',
  '/contact': 'contact',
  '/contact/': 'contact',
  
  // Privacy Policy (shared wrapper + leftover localized slugs)
  '/privacy': 'privacy',
  '/privacy/': 'privacy',
  '/ochrana-udajov': 'privacy',
  '/ochrana-udajov/': 'privacy',
  '/ochrana-udaju': 'privacy',
  '/ochrana-udaju/': 'privacy',
  '/privatlivspolitik': 'privacy',
  '/privatlivspolitik/': 'privacy',
  '/privacy-policy': 'privacy',
  '/privacy-policy/': 'privacy',
  
  // Terms of Service (shared wrapper + leftover localized slugs)
  '/terms': 'terms',
  '/terms/': 'terms',
  '/obchodne-podmienky': 'terms',
  '/obchodne-podmienky/': 'terms',
  '/obchodni-podminky': 'terms',
  '/obchodni-podminky/': 'terms',
  '/handelsbetingelser': 'terms',
  '/handelsbetingelser/': 'terms',
  '/terms-of-service': 'terms',
  '/terms-of-service/': 'terms',
  
  // Cookie Policy
  '/cookies': 'cookies',
  '/cookies/': 'cookies',

  // GDPR rights — leftover slug maps to the privacy wrapper
  '/gdpr': 'privacy',
  '/gdpr/': 'privacy',

  // Data Processing Agreement
  '/dpa': 'dpa',
  '/dpa/': 'dpa',
  
  // Blog
  '/blog': 'blog',
  '/blog/': 'blog',
  
  // Partners (SK & CS share /partneri/, resolved by domain)
  '/partneri': 'partners',
  '/partneri/': 'partners',
  '/partnere': 'partners',
  '/partnere/': 'partners',
  '/partners': 'partners',
  '/partners/': 'partners',
  
  // Video library (SK & CS share /videa/, resolved by domain)
  '/videa': 'videos',
  '/videa/': 'videos',
  '/videoer': 'videos',
  '/videoer/': 'videos',
  '/videos': 'videos',
  '/videos/': 'videos',
  
  // Bank Connect format template (Danish only)
  '/bank-connect': 'bankConnect',
  '/bank-connect/': 'bankConnect',

  // Danish migration guide used by comparison-page CTAs
  '/skift-til-bidmio': 'migrationGuide',
  '/skift-til-bidmio/': 'migrationGuide',

  // Danish painter price-calculator pilot
  '/prisberegner-til-maler': 'priceCalculatorPainter',
  '/prisberegner-til-maler/': 'priceCalculatorPainter',
  '/cenova-kalkulacka-pro-malire': 'priceCalculatorPainter',
  '/cenova-kalkulacka-pro-malire/': 'priceCalculatorPainter',
  '/cenova-kalkulacka-pre-maliarov': 'priceCalculatorPainter',
  '/cenova-kalkulacka-pre-maliarov/': 'priceCalculatorPainter',
  '/prisberegner-til-gulvfirma': 'priceCalculatorFloor',
  '/prisberegner-til-gulvfirma/': 'priceCalculatorFloor',
  
  // Technology & Security (shared wrapper + leftover localized slugs)
  '/security': 'technology',
  '/security/': 'technology',
  '/security/subprocessors': 'securitySubprocessors',
  '/security/subprocessors/': 'securitySubprocessors',
  '/security/data-map': 'securityDataMap',
  '/security/data-map/': 'securityDataMap',
  '/status': 'status',
  '/status/': 'status',
  '/technologie': 'technology',
  '/technologie/': 'technology',
  '/teknologi': 'technology',
  '/teknologi/': 'technology',
  '/technology': 'technology',
  '/technology/': 'technology',

  // Construction software category pillar (SK/CZ/DK; hidden on .com)
  '/stavebny-software': 'constructionSoftware',
  '/stavebny-software/': 'constructionSoftware',
  '/stavebni-software': 'constructionSoftware',
  '/stavebni-software/': 'constructionSoftware',
  '/byggesoftware': 'constructionSoftware',
  '/byggesoftware/': 'constructionSoftware',

  '/webstranka-pre-remeselnika': 'tradeWebsite',
  '/webstranka-pre-remeselnika/': 'tradeWebsite',
  '/webova-stranka-pro-remeslnika': 'tradeWebsite',
  '/webova-stranka-pro-remeslnika/': 'tradeWebsite',
  '/hjemmeside-til-haandvaerker': 'tradeWebsite',
  '/hjemmeside-til-haandvaerker/': 'tradeWebsite',
  '/website-for-tradespeople': 'tradeWebsite',
  '/website-for-tradespeople/': 'tradeWebsite',

  '/webova-stranka-pro-stavebni-firmy': 'constructionFirmWebsite',
  '/webova-stranka-pro-stavebni-firmy/': 'constructionFirmWebsite',
  '/hjemmeside-til-byggefirma': 'constructionFirmWebsite',
  '/hjemmeside-til-byggefirma/': 'constructionFirmWebsite',
  '/website-for-construction-companies': 'constructionFirmWebsite',
  '/website-for-construction-companies/': 'constructionFirmWebsite',

  '/webova-stranka-pro-servisni-firmy': 'serviceFirmWebsite',
  '/webova-stranka-pro-servisni-firmy/': 'serviceFirmWebsite',
  '/hjemmeside-til-servicefirma': 'serviceFirmWebsite',
  '/hjemmeside-til-servicefirma/': 'serviceFirmWebsite',
  '/website-for-service-firms': 'serviceFirmWebsite',
  '/website-for-service-firms/': 'serviceFirmWebsite',

  '/tvorba-webu-pre-remeselnikov': 'websiteCreation',
  '/tvorba-webu-pre-remeselnikov/': 'websiteCreation',
  '/tvorba-webu-pro-remeslniky': 'websiteCreation',
  '/tvorba-webu-pro-remeslniky/': 'websiteCreation',
  '/vi-laver-hjemmesiden': 'websiteCreation',
  '/vi-laver-hjemmesiden/': 'websiteCreation',
  '/website-creation-for-tradespeople': 'websiteCreation',
  '/website-creation-for-tradespeople/': 'websiteCreation',

  '/cenova-kalkulacka-pre-remeselnikov': 'priceCalculator',
  '/cenova-kalkulacka-pre-remeselnikov/': 'priceCalculator',
  '/cenova-kalkulacka-pro-remeslniky': 'priceCalculator',
  '/cenova-kalkulacka-pro-remeslniky/': 'priceCalculator',
  '/prisberegner-til-haandvaerker': 'priceCalculator',
  '/prisberegner-til-haandvaerker/': 'priceCalculator',
  '/price-calculator-for-tradespeople': 'priceCalculator',
  '/price-calculator-for-tradespeople/': 'priceCalculator',

  '/informacny-system-pre-firmu': 'wholeFirm',
  '/informacny-system-pre-firmu/': 'wholeFirm',
  '/cela-firma-v-jednom': 'wholeFirm',
  '/cela-firma-v-jednom/': 'wholeFirm',
  '/hele-firmaet-i-et-system': 'wholeFirm',
  '/hele-firmaet-i-et-system/': 'wholeFirm',
  '/the-whole-firm-in-one-system': 'wholeFirm',
  '/the-whole-firm-in-one-system/': 'wholeFirm',

  '/construction-software': 'constructionSoftware',
  '/construction-software/': 'constructionSoftware',

  '/ai-v-bidmio': 'aiAssistant',
  '/ai-v-bidmio/': 'aiAssistant',
  '/ai-v-bidmiu': 'aiAssistant',
  '/ai-v-bidmiu/': 'aiAssistant',
  '/ai-i-bidmio': 'aiAssistant',
  '/ai-i-bidmio/': 'aiAssistant',
  '/ai-in-bidmio': 'aiAssistant',
  '/ai-in-bidmio/': 'aiAssistant',

  // Solo / živnostník / OSVČ / enkeltmand landing
  '/ked-chyba-robota-a-peniaze': 'worldSurvive',
  '/ked-chyba-robota-a-peniaze/': 'worldSurvive',
  '/ked-chyba-poriadok': 'worldGrow',
  '/ked-chyba-poriadok/': 'worldGrow',
  '/praca-na-cierno': 'blackWorkArticle',
  '/praca-na-cierno/': 'blackWorkArticle',
  '/uctovnictvo-a-uctovnicka': 'accountantArticle',
  '/uctovnictvo-a-uctovnicka/': 'accountantArticle',
  '/naar-opgaverne-mangler': 'worldSurvive',
  '/naar-opgaverne-mangler/': 'worldSurvive',
  '/naar-overblikket-mangler': 'worldGrow',
  '/naar-overblikket-mangler/': 'worldGrow',
  '/sort-arbejde-i-byggeriet': 'blackWorkArticle',
  '/sort-arbejde-i-byggeriet/': 'blackWorkArticle',
  '/bogfoering-bilag-og-revisor': 'accountantArticle',
  '/bogfoering-bilag-og-revisor/': 'accountantArticle',
  '/kdyz-chybi-prace-a-penize': 'worldSurvive',
  '/kdyz-chybi-prace-a-penize/': 'worldSurvive',
  '/kdyz-chybi-poradek': 'worldGrow',
  '/kdyz-chybi-poradek/': 'worldGrow',
  '/prace-nacerno': 'blackWorkArticle',
  '/prace-nacerno/': 'blackWorkArticle',
  '/ucetnictvi-a-ucetni': 'accountantArticle',
  '/ucetnictvi-a-ucetni/': 'accountantArticle',
  '/when-money-is-tight': 'worldSurvive',
  '/when-money-is-tight/': 'worldSurvive',
  '/when-the-business-grows': 'worldGrow',
  '/when-the-business-grows/': 'worldGrow',
  '/cash-in-hand-work': 'blackWorkArticle',
  '/cash-in-hand-work/': 'blackWorkArticle',
  '/bookkeeping-and-your-accountant': 'accountantArticle',
  '/bookkeeping-and-your-accountant/': 'accountantArticle',
  '/pre-zivnostnikov': 'soloOffer',
  '/pre-zivnostnikov/': 'soloOffer',
  '/pro-osvc': 'soloOffer',
  '/pro-osvc/': 'soloOffer',
  '/til-enkeltmandsvirksomhed': 'soloOffer',
  '/til-enkeltmandsvirksomhed/': 'soloOffer',
  '/for-sole-traders': 'soloOffer',
  '/for-sole-traders/': 'soloOffer',

  '/software-pre-murarov': 'tradeMason',
  '/software-pre-murarov/': 'tradeMason',
  '/software-til-murer': 'tradeMason',
  '/software-til-murer/': 'tradeMason',
  '/software-til-tagdaekker': 'tradeRoofer',
  '/software-til-tagdaekker/': 'tradeRoofer',
  '/software-pre-pokryvacov': 'tradeRoofer',
  '/software-pre-pokryvacov/': 'tradeRoofer',
  '/software-pro-pokryvace': 'tradeRoofer',
  '/software-pro-pokryvace/': 'tradeRoofer',
  '/software-for-roofers': 'tradeRoofer',
  '/software-for-roofers/': 'tradeRoofer',
  '/software-fuer-dachdecker': 'tradeRoofer',
  '/software-fuer-dachdecker/': 'tradeRoofer',
  '/software-til-kloakmester': 'tradeSewer',
  '/software-til-kloakmester/': 'tradeSewer',
  '/software-pre-elektrikarov': 'tradeElectrician',
  '/software-pre-elektrikarov/': 'tradeElectrician',
  '/software-pro-elektrikare': 'tradeElectrician',
  '/software-pro-elektrikare/': 'tradeElectrician',
  '/software-til-elektriker': 'tradeElectrician',
  '/software-til-elektriker/': 'tradeElectrician',
  '/software-for-electricians': 'tradeElectrician',
  '/software-for-electricians/': 'tradeElectrician',
  '/software-pre-instalaterov': 'tradePlumber',
  '/software-pre-instalaterov/': 'tradePlumber',
  '/software-pro-instalatery': 'tradePlumber',
  '/software-pro-instalatery/': 'tradePlumber',
  '/software-til-vvs': 'tradePlumber',
  '/software-til-vvs/': 'tradePlumber',
  '/software-for-plumbers': 'tradePlumber',
  '/software-for-plumbers/': 'tradePlumber',
  '/software-pre-maliarov': 'tradePainter',
  '/software-pre-maliarov/': 'tradePainter',
  '/software-pro-malire': 'tradePainter',
  '/software-pro-malire/': 'tradePainter',
  '/software-til-maler': 'tradePainter',
  '/software-til-maler/': 'tradePainter',
  '/software-for-painters': 'tradePainter',
  '/software-for-painters/': 'tradePainter',
  '/software-pre-stolarov-a-tesarov': 'tradeCarpenter',
  '/software-pre-stolarov-a-tesarov/': 'tradeCarpenter',
  '/software-pro-truhlare-a-tesare': 'tradeCarpenter',
  '/software-pro-truhlare-a-tesare/': 'tradeCarpenter',
  '/software-til-toemrer': 'tradeCarpenter',
  '/software-til-toemrer/': 'tradeCarpenter',
  '/software-for-carpenters': 'tradeCarpenter',
  '/software-for-carpenters/': 'tradeCarpenter',
  '/software-pre-generalneho-dodavatela': 'tradeGeneralContractor',
  '/software-pre-generalneho-dodavatela/': 'tradeGeneralContractor',
  '/software-pro-generalniho-dodavatele': 'tradeGeneralContractor',
  '/software-pro-generalniho-dodavatele/': 'tradeGeneralContractor',
  '/software-til-hovedentreprenor': 'tradeGeneralContractor',
  '/software-til-hovedentreprenor/': 'tradeGeneralContractor',
  '/software-for-general-contractors': 'tradeGeneralContractor',
  '/software-for-general-contractors/': 'tradeGeneralContractor',
  '/servisny-system': 'tradeService',
  '/servisny-system/': 'tradeService',
  '/servisni-system': 'tradeService',
  '/servisni-system/': 'tradeService',
  '/servicesystem': 'tradeService',
  '/servicesystem/': 'tradeService',
  '/field-service-software': 'tradeService',
  '/field-service-software/': 'tradeService',
  '/zakaznicky-portal': 'customerPortal',
  '/zakaznicky-portal/': 'customerPortal',
  '/kundeportal': 'customerPortal',
  '/kundeportal/': 'customerPortal',
  '/customer-portal': 'customerPortal',
  '/customer-portal/': 'customerPortal',
  '/bozp-software': 'bozp',
  '/bozp-software/': 'bozp',
  '/arbejdsmiljo': 'bozp',
  '/arbejdsmiljo/': 'bozp',
  '/health-and-safety-software': 'bozp',
  '/health-and-safety-software/': 'bozp',
  '/pre-uctovnikov': 'forAccountants',
  '/pre-uctovnikov/': 'forAccountants',
  '/pro-ucetni': 'forAccountants',
  '/pro-ucetni/': 'forAccountants',
  '/til-revisorer': 'forAccountants',
  '/til-revisorer/': 'forAccountants',
  '/for-accountants': 'forAccountants',
  '/for-accountants/': 'forAccountants',
  '/digital-bogfoering': 'digitalBookkeeping',
  '/digital-bogfoering/': 'digitalBookkeeping',

  // Comparison hub (Bidmio vs competitors) — hidden on .com (en)
  '/porovnanie': 'comparisonHub',
  '/porovnanie/': 'comparisonHub',
  '/srovnani': 'comparisonHub',
  '/srovnani/': 'comparisonHub',
  '/sammenlign': 'comparisonHub',
  '/sammenlign/': 'comparisonHub',

  // Comparison pages - Danish competitors exist only on bidmio.dk
  '/sammenlign/bidmio-vs-minuba': 'comparisonMinuba',
  '/sammenlign/bidmio-vs-minuba/': 'comparisonMinuba',
  '/sammenlign/bidmio-vs-ordrestyring': 'comparisonOrdrestyring',
  '/sammenlign/bidmio-vs-ordrestyring/': 'comparisonOrdrestyring',
  '/sammenlign/bidmio-vs-apacta': 'comparisonApacta',
  '/sammenlign/bidmio-vs-apacta/': 'comparisonApacta',
  '/sammenlign/bidmio-vs-kala': 'comparisonKala',
  '/sammenlign/bidmio-vs-kala/': 'comparisonKala',
  '/sammenlign/bidmio-vs-e-conomic': 'comparisonEconomic',
  '/sammenlign/bidmio-vs-e-conomic/': 'comparisonEconomic',
  '/sammenlign/bidmio-vs-e-komplet': 'comparisonEkomplet',
  '/sammenlign/bidmio-vs-e-komplet/': 'comparisonEkomplet',

  // Comparison pages - local SK/CZ competitors exist only on bidmio.sk / bidmio.cz
  '/porovnanie/bidmio-vs-kros': 'comparisonKros',
  '/porovnanie/bidmio-vs-kros/': 'comparisonKros',
  '/srovnani/bidmio-vs-kros': 'comparisonKros',
  '/srovnani/bidmio-vs-kros/': 'comparisonKros',
  '/porovnanie/bidmio-vs-planradar': 'comparisonPlanradar',
  '/porovnanie/bidmio-vs-planradar/': 'comparisonPlanradar',
  '/srovnani/bidmio-vs-planradar': 'comparisonPlanradar',
  '/srovnani/bidmio-vs-planradar/': 'comparisonPlanradar',
  '/porovnanie/bidmio-vs-pohoda': 'comparisonPohoda',
  '/porovnanie/bidmio-vs-pohoda/': 'comparisonPohoda',
  '/srovnani/bidmio-vs-pohoda': 'comparisonPohoda',
  '/srovnani/bidmio-vs-pohoda/': 'comparisonPohoda',
  '/porovnanie/bidmio-vs-stavario': 'comparisonStavario',
  '/porovnanie/bidmio-vs-stavario/': 'comparisonStavario',
  '/srovnani/bidmio-vs-stavario': 'comparisonStavario',
  '/srovnani/bidmio-vs-stavario/': 'comparisonStavario',
  '/porovnanie/bidmio-vs-superfaktura': 'comparisonSuperfaktura',
  '/porovnanie/bidmio-vs-superfaktura/': 'comparisonSuperfaktura',
  '/porovnanie/bidmio-vs-idoklad': 'comparisonIdoklad',
  '/porovnanie/bidmio-vs-idoklad/': 'comparisonIdoklad',
  '/srovnani/bidmio-vs-idoklad': 'comparisonIdoklad',
  '/srovnani/bidmio-vs-idoklad/': 'comparisonIdoklad',
  '/sammenlign/bidmio-vs-dinero': 'comparisonDinero',
  '/sammenlign/bidmio-vs-dinero/': 'comparisonDinero',
  '/sammenlign/bidmio-vs-billy': 'comparisonBilly',
  '/sammenlign/bidmio-vs-billy/': 'comparisonBilly',

  // Blog Articles (support both with and without trailing slashes)
  '/blog/riadenie-zakaziek-pre-remeselnkov': 'blogOrderManagement',
  '/blog/riadenie-zakaziek-pre-remeselnkov/': 'blogOrderManagement',
  '/blog/rizeni-zakazek-pro-remeslniky': 'blogOrderManagement',
  '/blog/rizeni-zakazek-pro-remeslniky/': 'blogOrderManagement',
  '/blog/digitalna-evidencia-casu-remesla': 'blogTimeRegistration',
  '/blog/digitalna-evidencia-casu-remesla/': 'blogTimeRegistration',
  '/blog/digitalni-evidence-casu-remeslnici': 'blogTimeRegistration',
  '/blog/digitalni-evidence-casu-remeslnici/': 'blogTimeRegistration',
  '/blog/digital-tidsregistrering-handvaerkere': 'blogTimeRegistration',
  '/blog/digital-tidsregistrering-handvaerkere/': 'blogTimeRegistration',
  '/blog/digital-time-tracking-craftsmen': 'blogTimeRegistration',
  '/blog/digital-time-tracking-craftsmen/': 'blogTimeRegistration',
  '/blog/qr-kody-na-stavbe': 'blogQrOnSite',
  '/blog/qr-kody-na-stavbe/': 'blogQrOnSite',
  '/blog/qr-kody-na-stavenisti': 'blogQrOnSite',
  '/blog/qr-kody-na-stavenisti/': 'blogQrOnSite',
  '/blog/qr-koder-paa-byggepladsen': 'blogQrOnSite',
  '/blog/qr-koder-paa-byggepladsen/': 'blogQrOnSite',
  '/blog/qr-codes-on-the-job-site': 'blogQrOnSite',
  '/blog/qr-codes-on-the-job-site/': 'blogQrOnSite',
  '/blog/ako-ziskat-zakazky-z-webu': 'blogWebsiteLeads',
  '/blog/ako-ziskat-zakazky-z-webu/': 'blogWebsiteLeads',
  '/blog/jak-ziskat-zakazky-z-webu': 'blogWebsiteLeads',
  '/blog/jak-ziskat-zakazky-z-webu/': 'blogWebsiteLeads',
  '/blog/cenova-kalkulacka-a-dopytovy-formular': 'blogQuoteFormCalculator',
  '/blog/cenova-kalkulacka-a-dopytovy-formular/': 'blogQuoteFormCalculator',
  '/blog/cenova-kalkulacka-a-poptavkovy-formular': 'blogQuoteFormCalculator',
  '/blog/cenova-kalkulacka-a-poptavkovy-formular/': 'blogQuoteFormCalculator',
  '/blog/system-riadenia-zakaziek-slovensko': 'blogOrderManagementSystems',
  '/blog/system-riadenia-zakaziek-slovensko/': 'blogOrderManagementSystems',
  '/blog/system-rizeni-zakazek-slovensko': 'blogOrderManagementSystems',
  '/blog/system-rizeni-zakazek-slovensko/': 'blogOrderManagementSystems',
  '/blog/system-rizeni-zakazek-cesko': 'blogOrderManagementSystems',
  '/blog/system-rizeni-zakazek-cesko/': 'blogOrderManagementSystems',
  '/blog/digitalny-pracovny-vykaz': 'blogDigitalWorkOrder',
  '/blog/digitalny-pracovny-vykaz/': 'blogDigitalWorkOrder',
  '/blog/digitalni-pracovni-vykaz': 'blogDigitalWorkOrder',
  '/blog/digitalni-pracovni-vykaz/': 'blogDigitalWorkOrder',
  '/blog/digital-arbejdsseddel': 'blogDigitalWorkOrder',
  '/blog/digital-arbejdsseddel/': 'blogDigitalWorkOrder',
  '/blog/digital-work-order': 'blogDigitalWorkOrder',
  '/blog/digital-work-order/': 'blogDigitalWorkOrder',
  '/blog/zabezpecenie-kvality-stavebnictvo': 'blogQualityAssurance',
  '/blog/zabezpecenie-kvality-stavebnictvo/': 'blogQualityAssurance',
  '/blog/zajisteni-kvality-stavebnictvi': 'blogQualityAssurance',
  '/blog/zajisteni-kvality-stavebnictvi/': 'blogQualityAssurance',
  '/blog/kvalitetssikring-byggeri': 'blogQualityAssurance',
  '/blog/kvalitetssikring-byggeri/': 'blogQualityAssurance',
  '/blog/quality-assurance-construction': 'blogQualityAssurance',
  '/blog/quality-assurance-construction/': 'blogQualityAssurance',
  '/blog/servisne-zmluvy-software': 'blogServiceAgreements',
  '/blog/servisne-zmluvy-software/': 'blogServiceAgreements',
  '/blog/servisni-smlouvy-software': 'blogServiceAgreements',
  '/blog/servisni-smlouvy-software/': 'blogServiceAgreements',
  '/blog/serviceaftaler-software': 'blogServiceAgreements',
  '/blog/serviceaftaler-software/': 'blogServiceAgreements',
  '/blog/service-agreements-software': 'blogServiceAgreements',
  '/blog/service-agreements-software/': 'blogServiceAgreements',
  '/blog/financne-riadenie-remesla': 'blogFinancialManagement',
  '/blog/financne-riadenie-remesla/': 'blogFinancialManagement',
  '/blog/financni-rizeni-remesla': 'blogFinancialManagement',
  '/blog/financni-rizeni-remesla/': 'blogFinancialManagement',
  '/blog/okonomistyring-handvaerker': 'blogFinancialManagement',
  '/blog/okonomistyring-handvaerker/': 'blogFinancialManagement',
  '/blog/financial-management-craftsmen': 'blogFinancialManagement',
  '/blog/financial-management-craftsmen/': 'blogFinancialManagement',
  '/blog/registracia-materialov-remesla': 'blogMaterialRegistration',
  '/blog/registracia-materialov-remesla/': 'blogMaterialRegistration',
  '/blog/registrace-materialu-remesla': 'blogMaterialRegistration',
  '/blog/registrace-materialu-remesla/': 'blogMaterialRegistration',
  '/blog/materialeregistrering-handvaerker': 'blogMaterialRegistration',
  '/blog/materialeregistrering-handvaerker/': 'blogMaterialRegistration',
  '/blog/material-registration-craftsmen': 'blogMaterialRegistration',
  '/blog/material-registration-craftsmen/': 'blogMaterialRegistration',
  '/blog/riadenie-zakazok-elektrikari': 'blogOrderManagementElectricians',
  '/blog/riadenie-zakazok-elektrikari/': 'blogOrderManagementElectricians',
  '/blog/rizeni-zakazek-elektrikari': 'blogOrderManagementElectricians',
  '/blog/rizeni-zakazek-elektrikari/': 'blogOrderManagementElectricians',
  '/blog/ordrestyring-elektrikere': 'blogOrderManagementElectricians',
  '/blog/ordrestyring-elektrikere/': 'blogOrderManagementElectricians',
  '/blog/order-management-electricians': 'blogOrderManagementElectricians',
  '/blog/order-management-electricians/': 'blogOrderManagementElectricians',
  '/blog/riadenie-zakazok-maliari': 'blogOrderManagementPainters',
  '/blog/riadenie-zakazok-maliari/': 'blogOrderManagementPainters',
  '/blog/rizeni-zakazek-maliri': 'blogOrderManagementPainters',
  '/blog/rizeni-zakazek-maliri/': 'blogOrderManagementPainters',
  '/blog/ordrestyring-malere': 'blogOrderManagementPainters',
  '/blog/ordrestyring-malere/': 'blogOrderManagementPainters',
  '/blog/order-management-painters': 'blogOrderManagementPainters',
  '/blog/order-management-painters/': 'blogOrderManagementPainters',
  '/blog/migracia-do-bidmio-z-pohoda-kros-money': 'blogMigrationToBidmio',
  '/blog/migracia-do-bidmio-z-pohoda-kros-money/': 'blogMigrationToBidmio',
  '/blog/migrace-do-bidmio-z-pohody-money-heliosu': 'blogMigrationToBidmio',
  '/blog/migrace-do-bidmio-z-pohody-money-heliosu/': 'blogMigrationToBidmio',
  '/blog/digitalizacia-stavebnej-firmy': 'blogDigitalizationGuide',
  '/blog/digitalizacia-stavebnej-firmy/': 'blogDigitalizationGuide',
  '/blog/digitalizace-stavebni-firmy': 'blogDigitalizationGuide',
  '/blog/digitalizace-stavebni-firmy/': 'blogDigitalizationGuide',
  '/blog/digitaliser-din-byggefirma': 'blogDigitalizationGuide',
  '/blog/digitaliser-din-byggefirma/': 'blogDigitalizationGuide',
  '/blog/digitalize-construction-company': 'blogDigitalizationGuide',
  '/blog/digitalize-construction-company/': 'blogDigitalizationGuide',
  '/blog/ako-ocenit-stavebne-prace': 'blogJobPricing',
  '/blog/ako-ocenit-stavebne-prace/': 'blogJobPricing',
  '/blog/jak-ocenit-stavebni-prace': 'blogJobPricing',
  '/blog/jak-ocenit-stavebni-prace/': 'blogJobPricing',
  '/blog/prissaetning-byggeopgaver': 'blogJobPricing',
  '/blog/prissaetning-byggeopgaver/': 'blogJobPricing',
  '/blog/how-to-price-construction-jobs': 'blogJobPricing',
  '/blog/how-to-price-construction-jobs/': 'blogJobPricing',
  '/blog/riadenie-stavebnych-projektov-kompletny-sprievodca': 'blogProjectManagementGuide',
  '/blog/riadenie-stavebnych-projektov-kompletny-sprievodca/': 'blogProjectManagementGuide',
  '/blog/rizeni-stavebnich-projektu-kompletni-pruvodce': 'blogProjectManagementGuide',
  '/blog/rizeni-stavebnich-projektu-kompletni-pruvodce/': 'blogProjectManagementGuide',
  '/blog/bygningsprojektledelse-komplet-guide': 'blogProjectManagementGuide',
  '/blog/bygningsprojektledelse-komplet-guide/': 'blogProjectManagementGuide',
  '/blog/construction-project-management-complete-guide': 'blogProjectManagementGuide',
  '/blog/construction-project-management-complete-guide/': 'blogProjectManagementGuide',
  '/blog/zakazkovy-system': 'blogJobManagementSystem',
  '/blog/zakazkovy-system/': 'blogJobManagementSystem',
  '/blog/ordresystem-til-handvaerkere': 'blogJobManagementSystem',
  '/blog/ordresystem-til-handvaerkere/': 'blogJobManagementSystem',
  '/blog/job-management-system': 'blogJobManagementSystem',
  '/blog/job-management-system/': 'blogJobManagementSystem',
  '/blog/supis-vykonanych-prac-vzor': 'blogConstructionDocsTemplates',
  '/blog/supis-vykonanych-prac-vzor/': 'blogConstructionDocsTemplates',
  '/blog/soupis-provedenych-praci-vzor': 'blogConstructionDocsTemplates',
  '/blog/soupis-provedenych-praci-vzor/': 'blogConstructionDocsTemplates',
  '/blog/stavebny-dozor-vs-stavbyveduci': 'blogSiteManagerVsSupervisor',
  '/blog/stavebny-dozor-vs-stavbyveduci/': 'blogSiteManagerVsSupervisor',
  '/blog/stavebni-dozor-vs-stavbyvedouci': 'blogSiteManagerVsSupervisor',
  '/blog/stavebni-dozor-vs-stavbyvedouci/': 'blogSiteManagerVsSupervisor',
  '/blog/ako-prezit-byrokraciu-stavebnictvo': 'blogDigitalBureaucracyGuide',
  '/blog/ako-prezit-byrokraciu-stavebnictvo/': 'blogDigitalBureaucracyGuide',
  '/blog/jak-prezit-byrokracii-stavebnictvi': 'blogDigitalBureaucracyGuide',
  '/blog/jak-prezit-byrokracii-stavebnictvi/': 'blogDigitalBureaucracyGuide',
  '/blog/ai-stavebny-dennik-hlasovy-zapis': 'blogAiSiteDiary',
  '/blog/ai-stavebny-dennik-hlasovy-zapis/': 'blogAiSiteDiary',
  '/blog/ai-stavebni-denik-hlasovy-zapis': 'blogAiSiteDiary',
  '/blog/ai-stavebni-denik-hlasovy-zapis/': 'blogAiSiteDiary',
  '/blog/servisny-protokol-vzor': 'blogServiceProtocol',
  '/blog/servisny-protokol-vzor/': 'blogServiceProtocol',
  '/blog/servisni-protokol-vzor': 'blogServiceProtocol',
  '/blog/servisni-protokol-vzor/': 'blogServiceProtocol',
  '/blog/elektronicka-fakturacia-2027-stavebne-firmy': 'blogEInvoicing2027Sk',
  '/blog/elektronicka-fakturacia-2027-stavebne-firmy/': 'blogEInvoicing2027Sk',
  '/blog/appka-alebo-system-pre-remeselnikov': 'blogAppVsSystem',
  '/blog/appka-alebo-system-pre-remeselnikov/': 'blogAppVsSystem',
  '/blog/aplikace-nebo-system-pro-remeslniky': 'blogAppVsSystem',
  '/blog/aplikace-nebo-system-pro-remeslniky/': 'blogAppVsSystem',
  '/blog/app-eller-system-til-haandvaerkere': 'blogAppVsSystem',
  '/blog/app-eller-system-til-haandvaerkere/': 'blogAppVsSystem',
  '/blog/app-or-system-for-tradespeople': 'blogAppVsSystem',
  '/blog/app-or-system-for-tradespeople/': 'blogAppVsSystem',
  '/blog/uctovnictvo-pre-stavebne-firmy': 'blogAccountingModule',
  '/blog/uctovnictvo-pre-stavebne-firmy/': 'blogAccountingModule',
  '/blog/ucetnictvi-pro-stavebni-firmy': 'blogAccountingModule',
  '/blog/ucetnictvi-pro-stavebni-firmy/': 'blogAccountingModule',
  '/blog/regnskabsprogram-til-haandvaerkere': 'blogAccountingModule',
  '/blog/regnskabsprogram-til-haandvaerkere/': 'blogAccountingModule',
  '/blog/construction-accounting-software-module': 'blogAccountingModule',
  '/blog/construction-accounting-software-module/': 'blogAccountingModule',
  '/blog/ai-v-stavebnictve': 'blogAiConstruction',
  '/blog/ai-v-stavebnictve/': 'blogAiConstruction',
  '/blog/ai-ve-stavebnictvi': 'blogAiConstruction',
  '/blog/ai-ve-stavebnictvi/': 'blogAiConstruction',
  '/blog/ai-i-byggebranchen': 'blogAiConstruction',
  '/blog/ai-i-byggebranchen/': 'blogAiConstruction',
  '/blog/ai-in-construction': 'blogAiConstruction',
  '/blog/ai-in-construction/': 'blogAiConstruction',
  '/blog/ai-agent-pre-stavebnu-firmu': 'blogAiAgentConstruction',
  '/blog/ai-agent-pre-stavebnu-firmu/': 'blogAiAgentConstruction',
  '/blog/ai-agent-pro-stavebni-firmy': 'blogAiAgentConstruction',
  '/blog/ai-agent-pro-stavebni-firmy/': 'blogAiAgentConstruction',
  '/blog/ai-agent-til-haandvaerkere': 'blogAiAgentConstruction',
  '/blog/ai-agent-til-haandvaerkere/': 'blogAiAgentConstruction',
  '/blog/ai-agent-for-contractors': 'blogAiAgentConstruction',
  '/blog/ai-agent-for-contractors/': 'blogAiAgentConstruction',
  '/blog/predpoved-nakladov-eac-etc': 'blogCostForecastingEac',
  '/blog/predpoved-nakladov-eac-etc/': 'blogCostForecastingEac',
  '/blog/predpoved-nakladu-eac-etc': 'blogCostForecastingEac',
  '/blog/predpoved-nakladu-eac-etc/': 'blogCostForecastingEac',
  '/blog/omkostningsprognose-eac-etc': 'blogCostForecastingEac',
  '/blog/omkostningsprognose-eac-etc/': 'blogCostForecastingEac',
  '/blog/cost-forecasting-eac-etc': 'blogCostForecastingEac',
  '/blog/cost-forecasting-eac-etc/': 'blogCostForecastingEac',
  '/blog/supis-prac-vykaz-vymer': 'blogBillOfQuantities',
  '/blog/supis-prac-vykaz-vymer/': 'blogBillOfQuantities',
  '/blog/soupis-praci-vykaz-vymer': 'blogBillOfQuantities',
  '/blog/soupis-praci-vykaz-vymer/': 'blogBillOfQuantities',
  '/blog/tilbudsliste-maengdefortegnelse': 'blogBillOfQuantities',
  '/blog/tilbudsliste-maengdefortegnelse/': 'blogBillOfQuantities',
  '/blog/bill-of-quantities': 'blogBillOfQuantities',
  '/blog/bill-of-quantities/': 'blogBillOfQuantities',
  '/blog/zmenove-listy-viacprace': 'blogChangeOrders',
  '/blog/zmenove-listy-viacprace/': 'blogChangeOrders',
  '/blog/zmenove-listy-viceprace': 'blogChangeOrders',
  '/blog/zmenove-listy-viceprace/': 'blogChangeOrders',
  '/blog/aendringsordrer-byggeri': 'blogChangeOrders',
  '/blog/aendringsordrer-byggeri/': 'blogChangeOrders',
  '/blog/change-orders-construction': 'blogChangeOrders',
  '/blog/change-orders-construction/': 'blogChangeOrders',
  '/blog/vykazy-reporting-stavebnictvo': 'blogConstructionReporting',
  '/blog/vykazy-reporting-stavebnictvo/': 'blogConstructionReporting',
  '/blog/vykazy-reporting-stavebnictvi': 'blogConstructionReporting',
  '/blog/vykazy-reporting-stavebnictvi/': 'blogConstructionReporting',
  '/blog/rapportering-byggeri': 'blogConstructionReporting',
  '/blog/rapportering-byggeri/': 'blogConstructionReporting',
  '/blog/construction-reporting': 'blogConstructionReporting',
  '/blog/construction-reporting/': 'blogConstructionReporting',
  '/blog/ganttov-diagram-harmonogram-stavby': 'blogGanttScheduling',
  '/blog/ganttov-diagram-harmonogram-stavby/': 'blogGanttScheduling',
  '/blog/ganttuv-diagram-harmonogram-stavby': 'blogGanttScheduling',
  '/blog/ganttuv-diagram-harmonogram-stavby/': 'blogGanttScheduling',
  '/blog/gantt-diagram-byggeplan': 'blogGanttScheduling',
  '/blog/gantt-diagram-byggeplan/': 'blogGanttScheduling',
  '/blog/gantt-chart-construction-schedule': 'blogGanttScheduling',
  '/blog/gantt-chart-construction-schedule/': 'blogGanttScheduling',
  '/blog/audit-historia-zmien-stavba': 'blogAuditTrail',
  '/blog/audit-historia-zmien-stavba/': 'blogAuditTrail',
  '/blog/audit-historie-zmen-stavba': 'blogAuditTrail',
  '/blog/audit-historie-zmen-stavba/': 'blogAuditTrail',
  '/blog/revisionsspor-byggeri': 'blogAuditTrail',
  '/blog/revisionsspor-byggeri/': 'blogAuditTrail',
  '/blog/audit-trail-construction': 'blogAuditTrail',
  '/blog/audit-trail-construction/': 'blogAuditTrail',
};

// German paths are registered from routeTranslations instead of by hand, so a
// new de slug cannot be forgotten here. Existing entries (shared slugs such as
// /kontakt/ or /blog/) keep their key.
for (const [routeKey, slugs] of Object.entries(routeTranslations)) {
  const path = slugs.de;
  if (!path || path === '/') continue;
  const bare = path.replace(/\/$/, '');
  if (!(path in pathnameToRouteKey)) pathnameToRouteKey[path] = routeKey;
  if (!(bare in pathnameToRouteKey)) pathnameToRouteKey[bare] = routeKey;
}

// Quiz pages (hourly rate, employee cost) are registered for every language the same way.
for (const [routeKey, slugs] of Object.entries(routeTranslations)) {
  if (!/^(quizHub|rateQuiz|employeeQuiz|vehicleQuiz|quoteQuiz|latePayerQuiz|freeWorkQuiz|hireQuiz|materialQuiz|quoteTool|rightsQuiz)/.test(routeKey)) continue;
  for (const path of Object.values(slugs)) {
    if (!path) continue;
    pathnameToRouteKey[path] = routeKey;
    pathnameToRouteKey[path.replace(/\/$/, '')] = routeKey;
  }
}


/**
 * Ensure a URL path has a trailing slash (except for home page)
 * @param path - The URL path
 * @returns The path with a trailing slash
 */
export function ensureTrailingSlash(path: string): string {
  // Home page should stay as '/'
  if (path === '/' || path === '') {
    return '/';
  }
  
  // Remove query params and hash for processing
  const [pathname, search] = path.split('?');
  const [pathOnly, hash] = (search ? pathname : path).split('#');
  
  // Add trailing slash if not present
  const normalizedPath = pathOnly.endsWith('/') ? pathOnly : `${pathOnly}/`;
  
  // Reconstruct with query params and hash
  let result = normalizedPath;
  if (search) result += `?${search}`;
  if (hash) result += `#${hash}`;
  
  return result;
}

/**
 * Get the translated module slug for a given language
 * @param canonicalSlug - The canonical Slovak slug
 * @param targetLang - The target language code (sk, cs, da, en)
 * @returns The translated slug or the original if no translation exists
 */
// Where a link to a module that a locale does not offer should point instead.
const UNAVAILABLE_MODULE_FALLBACK: Record<string, string> = {
  uctovnictvo: 'spracovanie-dokladov',
  mzdy: 'vykaz-prace-a-evidencia-dochadzky',
  bankovnictvo: 'online-fakturacia',
};

export function getTranslatedModuleSlug(canonicalSlug: string, targetLang: 'sk' | 'cs' | 'da' | 'en' | 'de'): string {
  const translations = moduleSlugTranslations[canonicalSlug];
  if (translations && translations[targetLang] === '') {
    const fallback = UNAVAILABLE_MODULE_FALLBACK[canonicalSlug];
    if (fallback) return moduleSlugTranslations[fallback][targetLang];
  }
  return translations?.[targetLang] || canonicalSlug;
}

/**
 * Whether a module page exists in a locale. An empty slug marks a module the
 * product does not offer in that market (accounting, payroll and banking in de).
 */
export function isModuleAvailable(canonicalSlug: string, lang: 'sk' | 'cs' | 'da' | 'en' | 'de'): boolean {
  const translations = moduleSlugTranslations[canonicalSlug];
  return !translations || translations[lang] !== '';
}

/**
 * Find the canonical slug from any language variant
 * @param slug - A slug in any language
 * @returns The canonical Slovak slug or the original slug if not found
 */
/** Retired localized slugs that still resolve to a canonical module. */
export const legacyModuleSlugAliases: Record<string, string> = {
  'tidregistrering-fravaer': 'vykaz-prace-a-evidencia-dochadzky',
};

export function getCanonicalModuleSlug(slug: string): string {
  if (legacyModuleSlugAliases[slug]) {
    return legacyModuleSlugAliases[slug];
  }

  // First check if it's already a canonical slug
  if (moduleSlugTranslations[slug]) {
    return slug;
  }
  
  // Search for the slug in all language variants
  for (const [canonicalSlug, translations] of Object.entries(moduleSlugTranslations)) {
    if (Object.values(translations).includes(slug)) {
      return canonicalSlug;
    }
  }
  
  // Fallback: return the original slug
  return slug;
}

export const SITE_LANGUAGES = ['sk', 'cs', 'da', 'en', 'de'] as const;
export type SiteLanguage = (typeof SITE_LANGUAGES)[number];

const CANONICAL_DOMAIN_BY_LANG: Record<SiteLanguage, string> = {
  sk: 'https://www.bidmio.sk',
  cs: 'https://www.bidmio.cz',
  da: 'https://www.bidmio.dk',
  en: 'https://www.bidmio.com',
  de: 'https://www.bidmio.de',
};

const LANGUAGE_ALIASES: Record<string, SiteLanguage> = {
  cz: 'cs',
};

/** Map `cz` / `sk-SK` to a site language, or null when unknown. */
export function resolveSiteLanguage(lang?: string | null): SiteLanguage | null {
  if (!lang) return null;
  const base = lang.toLowerCase().split(/[-_]/)[0];
  if (LANGUAGE_ALIASES[base]) return LANGUAGE_ALIASES[base];
  return (SITE_LANGUAGES as readonly string[]).includes(base)
    ? (base as SiteLanguage)
    : null;
}

/** Normalize i18n codes like `sk-SK` / `da_DK` / `cz` to a site language. */
export function normalizeSiteLanguage(lang?: string | null): SiteLanguage {
  return resolveSiteLanguage(lang) ?? 'sk';
}

/**
 * Get route path by canonical route key
 * @param routeKey - The canonical route key (e.g., 'privacy', 'terms', 'pricing')
 * @param lang - The target language code (sk, cs, da, en)
 * @returns The localized path for that route
 */
export function getRouteByKey(routeKey: string, lang: 'sk' | 'cs' | 'da' | 'en' | 'de'): string {
  return routeTranslations[routeKey]?.[normalizeSiteLanguage(lang)] || '/';
}

/**
 * Get the localized URL path for a given pathname and target language
 * @param currentPath - The current pathname (in any language)
 * @param targetLang - The target language code (sk, cs, da, en)
 * @returns The localized path for the target language with trailing slash
 */
export function getLocalizedPath(currentPath: string, targetLang: 'sk' | 'cs' | 'da' | 'en' | 'de'): string {
  const lang = normalizeSiteLanguage(targetLang);
  // Normalize path (remove trailing slash, query params)
  const normalizedPath = (currentPath || '/').split('?')[0].replace(/\/$/, '') || '/';
  
  // Check if it's a module detail page (e.g., /moduly/projektove-riadenie)
  if (normalizedPath.startsWith('/moduly/') || 
      normalizedPath.startsWith('/funktioner/') || 
      normalizedPath.startsWith('/funktionen/') || 
      normalizedPath.startsWith('/features/')) {
    
    // Extract the module slug (last part of the path)
    const parts = normalizedPath.split('/').filter(Boolean);
    const currentSlug = parts[parts.length - 1];
    
    // Get canonical slug first (in case we're coming from a non-Slovak URL)
    const canonicalSlug = getCanonicalModuleSlug(currentSlug);
    
    // A module the product does not offer in this locale has no page there.
    if (!isModuleAvailable(canonicalSlug, lang)) return '';

    // Translate the slug to target language
    const translatedSlug = getTranslatedModuleSlug(canonicalSlug, lang);
    
    // Get the base modules path for target language (already has trailing slash)
    const basePath = routeTranslations.modules[lang];
    // basePath already ends with /, so just append the slug and add trailing slash
    return `${basePath}${translatedSlug}/`;
  }
  
  // Look up the route key
  const routeKey = pathnameToRouteKey[normalizedPath];
  
  // If we have a translation entry, return it (already has trailing slash).
  // Empty string means "unavailable in this locale" and must be preserved for
  // hreflang/sitemap callers — do not substitute the original path here.
  if (routeKey && routeTranslations[routeKey]) {
    return routeTranslations[routeKey][lang];
  }
  
  // Fallback: return the original path with trailing slash
  return ensureTrailingSlash(normalizedPath);
}

/**
 * Check whether a route exists in a locale (routeTranslations value is not '').
 * Use this instead of getRouteByKey(...) !== '' — getRouteByKey maps '' to '/'
 * via its fallback, so it can never signal unavailability.
 */
export function isRouteAvailable(routeKey: string, lang: 'sk' | 'cs' | 'da' | 'en' | 'de'): boolean {
  const translations = routeTranslations[routeKey as keyof typeof routeTranslations];
  return Boolean(translations && translations[lang]);
}

/**
 * Infer language from a locale-unique path (e.g. /sammenlign/ → da).
 * Shared slugs like /kontakt/ return null so they do not flip the locale.
 */
export function getLanguageFromUniquePath(pathname: string): SiteLanguage | null {
  const normalized = ensureTrailingSlash((pathname || '/').split('?')[0].split('#')[0]);
  const routeKey = pathnameToRouteKey[normalized];
  if (routeKey && routeTranslations[routeKey]) {
    const matching = SITE_LANGUAGES.filter(
      (lang) => routeTranslations[routeKey][lang] === normalized,
    );
    if (matching.length === 1) return matching[0];
  }
  if (normalized.startsWith('/funktionen/')) return 'de';
  if (normalized.startsWith('/sammenlign/')) return 'da';
  if (normalized.startsWith('/porovnanie/')) return 'sk';
  if (normalized.startsWith('/srovnani/')) return 'cs';
  return null;
}

/**
 * Get all alternate language URLs for the current page
 * @param currentPath - The current pathname
 * @returns Array of { lang, url } objects for all supported languages
 */
export function getAlternateLanguageUrls(currentPath: string): Array<{ lang: 'sk' | 'cs' | 'da' | 'en' | 'de', url: string, domain: string }> {
  const domainMap = {
    sk: 'https://www.bidmio.sk',
    cs: 'https://www.bidmio.cz',
    da: 'https://www.bidmio.dk',
    en: 'https://www.bidmio.com',
    de: 'https://www.bidmio.de',
  };
  
  return SITE_LANGUAGES
    .map(lang => {
      const localizedPath = getLocalizedPath(currentPath, lang);
      return {
        lang,
        domain: domainMap[lang],
        localizedPath,
        url: `${domainMap[lang]}${localizedPath}`,
      };
    })
    // Routes that exist only in some languages have empty localized paths —
    // exclude them so we never emit hreflang alternates pointing at the domain root
    .filter(({ localizedPath }) => localizedPath !== '')
    .map(({ lang, domain, url }) => ({ lang, domain, url }));
}

/**
 * Get the canonical URL for the current page
 * @param currentPath - The current pathname
 * @param currentLang - The current language (optional; missing/invalid values are normalized)
 * @returns The canonical URL
 */
export function getCanonicalUrl(currentPath: string, currentLang?: string | null): string {
  const lang = normalizeSiteLanguage(currentLang);
  const inputPath = currentPath || '/';
  const localizedPath = getLocalizedPath(inputPath, lang);
  // '' means unavailable in this locale — still emit a usable absolute URL for
  // JSON-LD (never concatenate undefined into "undefinedundefined").
  const path = localizedPath || ensureTrailingSlash(inputPath);
  return `${CANONICAL_DOMAIN_BY_LANG[lang]}${path}`;
}
